export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Email: { input: any; output: any; }
  /** Timestamp as RFC3339-formatted string */
  Time: { input: any; output: any; }
  /** Represents untyped JSON */
  JSON: { input: any; output: any; }
};

export type Query = {
  readonly __typename: 'Query';
  /** Cochrane-specific data */
  readonly cochrane: Cochrane;
  readonly comments?: Maybe<CommentConnection>;
  readonly guidelines?: Maybe<GuidelineConnection>;
  /** The currently authenticated user */
  readonly me?: Maybe<User>;
  /** Fetches an object given its ID. */
  readonly node?: Maybe<Node>;
  readonly ping: Scalars['String']['output'];
  readonly reviews: ReviewConnection;
};


export type QueryCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter: CommentsFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<CommentSort>;
  sortDirection?: InputMaybe<SortDirection>;
};


export type QueryGuidelinesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryNodeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryReviewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type Cochrane = {
  readonly __typename: 'Cochrane';
  readonly isConnected: Scalars['Boolean']['output'];
  readonly reviews: CochraneReviewConnection;
};


export type CochraneReviewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  linkStatus?: InputMaybe<LinkStatus>;
};

export enum LinkStatus {
  All = 'ALL',
  Linked = 'LINKED',
  Unlinked = 'UNLINKED'
}

/** The connection type for CochraneReview. */
export type CochraneReviewConnection = {
  readonly __typename: 'CochraneReviewConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<CochraneReviewEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<CochraneReview>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
};

/** An edge in a connection. */
export type CochraneReviewEdge = {
  readonly __typename: 'CochraneReviewEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<CochraneReview>;
};

export type CochraneReview = Node & {
  readonly __typename: 'CochraneReview';
  readonly cdNumber?: Maybe<Scalars['String']['output']>;
  readonly cochraneId: Scalars['ID']['output'];
  readonly id: Scalars['ID']['output'];
  readonly link?: Maybe<CochraneReviewLink>;
  readonly title: Scalars['String']['output'];
};

/** An object with an ID. */
export type Node = {
  /** ID of the object. */
  readonly id: Scalars['ID']['output'];
};

export type CochraneReviewLink = Node & {
  readonly __typename: 'CochraneReviewLink';
  readonly cochraneReview: CochraneReview;
  readonly covidenceReview: Review;
  readonly crsPendingStudiesCount?: Maybe<Scalars['Int']['output']>;
  readonly id: Scalars['ID']['output'];
};

export type Review = HasDuplicatesInterface & Node & {
  readonly __typename: 'Review';
  readonly assignedAdministrator?: Maybe<User>;
  readonly cochraneReviewLink?: Maybe<CochraneReviewLink>;
  readonly collaborators: UserConnection;
  readonly createdAt: Scalars['Time']['output'];
  readonly creator: User;
  readonly currentImport?: Maybe<Import>;
  readonly dbId: Scalars['ID']['output'];
  readonly deletedAt?: Maybe<Scalars['Time']['output']>;
  readonly duplicates: DuplicateConnection;
  readonly enabledFeatures: ReadonlyArray<Scalars['String']['output']>;
  readonly excludedKeywords: ReadonlyArray<Scalars['String']['output']>;
  readonly extractionForms: ExtractionFormConnection;
  readonly extractionStudies: ExtractionStudyConnection;
  readonly id: Scalars['ID']['output'];
  readonly imports: ImportConnection;
  readonly includedKeywords: ReadonlyArray<Scalars['String']['output']>;
  readonly invites: InviteConnection;
  readonly lastActivityAt: Scalars['Time']['output'];
  readonly memberships: ReviewMembershipConnection;
  readonly owner: AccountOwner;
  readonly studies: StudyConnection;
  readonly studiesAvailableForVoting: ReadonlyArray<Study>;
  readonly tags: ReadonlyArray<Tag>;
  readonly title: Scalars['String']['output'];
};


export type ReviewCollaboratorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ReviewDuplicatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reviewStudyId?: InputMaybe<Scalars['Int']['input']>;
};


export type ReviewExtractionFormsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ReviewExtractionStudiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ExtractionStudiesFilter>;
  filterByTags?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ExtractionStudySort>;
  sortDirection?: InputMaybe<SortDirection>;
  studyId?: InputMaybe<Scalars['ID']['input']>;
};


export type ReviewImportsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  finalized?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ReviewInvitesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ReviewMembershipsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ReviewStudiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<StudiesFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<StudySort>;
  sortDirection?: InputMaybe<SortDirection>;
};


export type ReviewStudiesAvailableForVotingArgs = {
  category: Category;
  excluding?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  reviewer: Scalars['ID']['input'];
};

export type HasDuplicatesInterface = {
  readonly duplicates: DuplicateConnection;
};


export type HasDuplicatesInterfaceDuplicatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reviewStudyId?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for DuplicateCluster. */
export type DuplicateConnection = {
  readonly __typename: 'DuplicateConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<DuplicateClusterEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<DuplicateCluster>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** The total number of system detected duplicates. */
  readonly systemDuplicates: Scalars['Int']['output'];
  /**
   * The total number of clusters of duplicates. Put another way, this is the number
   * of _original_ items with one or more associated duplicates.
   */
  readonly total: Scalars['Int']['output'];
  /** The total number of duplicates. */
  readonly totalDuplicates: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DuplicateClusterEdge = {
  readonly __typename: 'DuplicateClusterEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<DuplicateCluster>;
};

export type DuplicateCluster = Node & {
  readonly __typename: 'DuplicateCluster';
  /** The category in which the current master resides */
  readonly category: Category;
  readonly covidenceNumber: Scalars['Int']['output'];
  readonly duplicates: ReadonlyArray<ReferenceInterface>;
  readonly id: Scalars['ID']['output'];
  /** The base review phase the reference study was last in (T&A, Full Text, or Extraction */
  readonly lastReviewPhase: Scalars['String']['output'];
  readonly master: ReferenceInterface;
};

export enum Category {
  /** Auto-excluded */
  Ae = 'AE',
  /** Duplicate */
  Dp = 'DP',
  /** Excluded */
  Ex = 'EX',
  /** Screening on full text */
  Ft = 'FT',
  /** Included */
  In = 'IN',
  /** Irrelevant */
  Ir = 'IR',
  /** Merged */
  Mg = 'MG',
  /** Screening on title & abstract */
  Ta = 'TA'
}

/**
 * An interface for any type which has citation data. Most fields are nullable
 * because data quality is inconsistent and many fields can be missing.
 */
export type ReferenceInterface = {
  /** The abstract of the report */
  readonly abstract?: Maybe<Scalars['String']['output']>;
  /** List of authors for the report */
  readonly authors: Scalars['String']['output'];
  /** Covidence Number of the associated review study */
  readonly covidenceNumber?: Maybe<Scalars['Int']['output']>;
  /** Digital Object Identifier */
  readonly doi?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['ID']['output']>;
  readonly primaryAuthor: Scalars['String']['output'];
  /**
   * Details about the report publication. Most data in these fields is
   * unstructured (i.e. as it appears in source material) and therefore
   * typed as Strings even where another type might be appropriate.
   */
  readonly publication?: Maybe<Publication>;
  /** The title of the report */
  readonly title?: Maybe<Scalars['String']['output']>;
};

/**
 * Details about the report publication. Most data in these fields is
 * unstructured (i.e. as it appears in source material) and therefore
 * typed as Strings even where another type might be appropriate.
 */
export type Publication = {
  readonly __typename: 'Publication';
  /** The journal issue in which the report appeared */
  readonly issue?: Maybe<Scalars['String']['output']>;
  /** The journal name in which the report appeared */
  readonly journal?: Maybe<Scalars['String']['output']>;
  /** The location in which the report was published */
  readonly location?: Maybe<Scalars['String']['output']>;
  /** The month in which the report was published */
  readonly month?: Maybe<Scalars['String']['output']>;
  /** The page or pages in which the report appeared in the issue */
  readonly pages?: Maybe<Scalars['String']['output']>;
  /** The publisher of the report or its journal */
  readonly publisher?: Maybe<Scalars['String']['output']>;
  /** The journal volume in which the report appeared */
  readonly volume?: Maybe<Scalars['String']['output']>;
  /** The year in which the report was published */
  readonly year?: Maybe<Scalars['String']['output']>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  readonly __typename: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

export type User = Node & {
  readonly __typename: 'User';
  readonly account: Account;
  readonly billableAccounts: AccountConnection;
  readonly consent: UserConsent;
  readonly dbId: Scalars['ID']['output'];
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
  readonly organization: Organization;
  readonly organizationMembership: Membership;
  readonly organizationMemberships: MembershipConnection;
  readonly primaryEmail: Scalars['Email']['output'];
};


export type UserBillableAccountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type UserConsentArgs = {
  name: Scalars['String']['input'];
};


export type UserOrganizationArgs = {
  id: Scalars['ID']['input'];
};


export type UserOrganizationMembershipArgs = {
  organization: Scalars['ID']['input'];
};


export type UserOrganizationMembershipsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type Account = Node & {
  readonly __typename: 'Account';
  readonly availablePlans: ReadonlyArray<Plan>;
  readonly availableReviewCount?: Maybe<Scalars['Int']['output']>;
  readonly canStartTrial: Scalars['Boolean']['output'];
  readonly hasTrialed: Scalars['Boolean']['output'];
  readonly id: Scalars['ID']['output'];
  readonly owner: AccountOwner;
  readonly screenLimit?: Maybe<Scalars['Int']['output']>;
};

export type Plan = {
  readonly __typename: 'Plan';
  readonly billingPeriodUnit: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
  readonly numberOfReviewers?: Maybe<Scalars['Int']['output']>;
  readonly numberOfReviews?: Maybe<Scalars['Int']['output']>;
  readonly price: Price;
  readonly screenLimit?: Maybe<Scalars['Int']['output']>;
};

export type Price = {
  readonly __typename: 'Price';
  readonly amount: Scalars['Int']['output'];
  readonly currency: Scalars['String']['output'];
};

export type AccountOwner = Organization | User;

export type Organization = Node & {
  readonly __typename: 'Organization';
  readonly account: Account;
  readonly administrators: UserConnection;
  readonly authors: UserConnection;
  readonly exports?: Maybe<ReadonlyArray<AuthorExport>>;
  readonly id: Scalars['ID']['output'];
  readonly invitations: InvitationConnection;
  readonly memberships: MembershipConnection;
  readonly name: Scalars['String']['output'];
  readonly reviews: ReviewConnection;
};


export type OrganizationAdministratorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<UserSort>;
  sortDirection?: InputMaybe<SortDirection>;
};


export type OrganizationAuthorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<OrganizationAuthorsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<UserSort>;
  sortDirection?: InputMaybe<SortDirection>;
};


export type OrganizationInvitationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<OrganizationInvitationsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type OrganizationMembershipsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<OrganizationMembershipsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type OrganizationReviewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<OrganizationReviewsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ReviewSort>;
  sortDirection?: InputMaybe<SortDirection>;
};

export enum UserSort {
  Name = 'NAME'
}

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** The connection type for User. */
export type UserConnection = {
  readonly __typename: 'UserConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<UserEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<User>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly total: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UserEdge = {
  readonly __typename: 'UserEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<User>;
};

export type OrganizationAuthorsFilter = {
  readonly search?: InputMaybe<Scalars['String']['input']>;
};

export type AuthorExport = Node & {
  readonly __typename: 'AuthorExport';
  readonly authenticatedUrl?: Maybe<Scalars['String']['output']>;
  readonly authorNameFilter?: Maybe<Scalars['String']['output']>;
  readonly completedAt?: Maybe<Scalars['String']['output']>;
  readonly createdAt: Scalars['String']['output'];
  readonly failed: Scalars['Boolean']['output'];
  readonly id: Scalars['ID']['output'];
  readonly sortDirection: SortDirection;
};

export type OrganizationInvitationsFilter = {
  readonly email?: InputMaybe<Scalars['String']['input']>;
};

/** The connection type for Invitation. */
export type InvitationConnection = {
  readonly __typename: 'InvitationConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<InvitationEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<Invitation>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
};

/** An edge in a connection. */
export type InvitationEdge = {
  readonly __typename: 'InvitationEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<Invitation>;
};

export type Invitation = Node & {
  readonly __typename: 'Invitation';
  readonly email: Scalars['Email']['output'];
  readonly expiresAt: Scalars['Time']['output'];
  readonly id: Scalars['ID']['output'];
  readonly name?: Maybe<Scalars['String']['output']>;
};

export type OrganizationMembershipsFilter = {
  readonly search?: InputMaybe<Scalars['String']['input']>;
};

/** The connection type for Membership. */
export type MembershipConnection = {
  readonly __typename: 'MembershipConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<MembershipEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<Membership>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
};

/** An edge in a connection. */
export type MembershipEdge = {
  readonly __typename: 'MembershipEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<Membership>;
};

export type Membership = Node & {
  readonly __typename: 'Membership';
  readonly assignedReviews: ReviewConnection;
  readonly id: Scalars['ID']['output'];
  readonly invitation?: Maybe<Invitation>;
  readonly member: User;
  readonly memberSince?: Maybe<Scalars['Time']['output']>;
  readonly organization: Organization;
  readonly organizationReviews?: Maybe<ReviewConnection>;
  readonly status: MembershipStatus;
};


export type MembershipAssignedReviewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type MembershipOrganizationReviewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for Review. */
export type ReviewConnection = {
  readonly __typename: 'ReviewConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<ReviewEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<Review>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly total: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ReviewEdge = {
  readonly __typename: 'ReviewEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<Review>;
};

export enum MembershipStatus {
  Admin = 'ADMIN',
  Member = 'MEMBER',
  NotAMember = 'NOT_A_MEMBER'
}

export type OrganizationReviewsFilter = {
  readonly assignedAdministrator?: InputMaybe<Scalars['ID']['input']>;
  readonly includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  readonly search?: InputMaybe<Scalars['String']['input']>;
};

export enum ReviewSort {
  CreatedAt = 'CREATED_AT',
  LastActivityAt = 'LAST_ACTIVITY_AT',
  Title = 'TITLE'
}

/** The connection type for Account. */
export type AccountConnection = {
  readonly __typename: 'AccountConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<AccountEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<Account>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
};

/** An edge in a connection. */
export type AccountEdge = {
  readonly __typename: 'AccountEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<Account>;
};

export type UserConsent = {
  readonly __typename: 'UserConsent';
  readonly decision: UserConsentDecision;
};

export enum UserConsentDecision {
  Consented = 'CONSENTED',
  Denied = 'DENIED',
  Outdated = 'OUTDATED',
  Unanswered = 'UNANSWERED'
}

export type Import = HasDuplicatesInterface & Node & {
  readonly __typename: 'Import';
  readonly createdAt: Scalars['Time']['output'];
  /** Default category into which imported studies will go */
  readonly defaultCategory: Category;
  readonly detectedCitationsCount: Scalars['Int']['output'];
  readonly duplicateCitationsCount: Scalars['Int']['output'];
  readonly duplicates: DuplicateConnection;
  readonly error?: Maybe<Error>;
  readonly id: Scalars['ID']['output'];
  readonly importedStudiesCount: Scalars['Int']['output'];
  readonly isFinished: Scalars['Boolean']['output'];
  readonly source: ImportSource;
  readonly state: ImportState;
};


export type ImportDuplicatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reviewStudyId?: InputMaybe<Scalars['Int']['input']>;
};

export type Error = {
  readonly __typename: 'Error';
  /** Unique error code */
  readonly code: Scalars['String']['output'];
  /** Message describing error */
  readonly message: Scalars['String']['output'];
};

export enum ImportSource {
  Crs = 'CRS',
  File = 'FILE',
  GuidelineTriage = 'GUIDELINE_TRIAGE',
  StudyTriage = 'STUDY_TRIAGE'
}

export enum ImportState {
  Failed = 'FAILED',
  Finalized = 'FINALIZED',
  Finalizing = 'FINALIZING',
  Imported = 'IMPORTED',
  Importing = 'IMPORTING',
  New = 'NEW',
  Prepared = 'PREPARED',
  Preparing = 'PREPARING',
  Sourced = 'SOURCED',
  Sourcing = 'SOURCING',
  UndoFailed = 'UNDO_FAILED',
  Undoing = 'UNDOING',
  Undone = 'UNDONE'
}

/** The connection type for ExtractionForm. */
export type ExtractionFormConnection = {
  readonly __typename: 'ExtractionFormConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<ExtractionFormEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<ExtractionForm>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ExtractionFormEdge = {
  readonly __typename: 'ExtractionFormEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<ExtractionForm>;
};

export type ExtractionForm = Node & {
  readonly __typename: 'ExtractionForm';
  readonly creator: User;
  readonly currentRevision: ExtractionFormRevision;
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
  readonly review: Review;
  readonly revisions: ExtractionFormRevisionConnection;
  readonly type: ExtractionFormType;
};


export type ExtractionFormRevisionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ExtractionFormRevision = Node & {
  readonly __typename: 'ExtractionFormRevision';
  readonly creator: User;
  readonly definition: Scalars['JSON']['output'];
  readonly form: ExtractionForm;
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
};

/** The connection type for ExtractionFormRevision. */
export type ExtractionFormRevisionConnection = {
  readonly __typename: 'ExtractionFormRevisionConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<ExtractionFormRevisionEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<ExtractionFormRevision>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ExtractionFormRevisionEdge = {
  readonly __typename: 'ExtractionFormRevisionEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<ExtractionFormRevision>;
};

export enum ExtractionFormType {
  DataExtraction = 'DATA_EXTRACTION',
  QualityAssessment = 'QUALITY_ASSESSMENT'
}

export type ExtractionStudiesFilter = {
  readonly status?: InputMaybe<ExtractionStudiesStatus>;
};

export enum ExtractionStudiesStatus {
  /** Complete */
  Complete = 'COMPLETE',
  /** Consensus required */
  ConsensusRequired = 'CONSENSUS_REQUIRED',
  /** In progress */
  InProgress = 'IN_PROGRESS',
  /** Not started */
  NotStarted = 'NOT_STARTED'
}

export enum ExtractionStudySort {
  Author = 'author',
  CovidenceNumber = 'covidence_number',
  MostRecent = 'most_recent',
  MostRelevantAi = 'most_relevant_ai',
  Relevancy = 'relevancy',
  Title = 'title'
}

/** The connection type for ExtractionStudy. */
export type ExtractionStudyConnection = {
  readonly __typename: 'ExtractionStudyConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<ExtractionStudyEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<ExtractionStudy>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly total: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ExtractionStudyEdge = {
  readonly __typename: 'ExtractionStudyEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<ExtractionStudy>;
};

export type ExtractionStudy = Node & {
  readonly __typename: 'ExtractionStudy';
  readonly actions: StudyActions;
  readonly authors?: Maybe<Scalars['String']['output']>;
  readonly covidenceNumber: Scalars['Int']['output'];
  readonly id: Scalars['ID']['output'];
  readonly notes: ReadonlyArray<Note>;
  readonly pdfUrl?: Maybe<Scalars['String']['output']>;
  readonly progress: ExtractionProgress;
  readonly references: ReportConnection;
  readonly studyId?: Maybe<Scalars['String']['output']>;
  readonly tags: ReadonlyArray<Scalars['String']['output']>;
  readonly title?: Maybe<Scalars['String']['output']>;
};


export type ExtractionStudyReferencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** URLs for user actions that can be taken on this study and urls for some. */
export type StudyActions = {
  readonly __typename: 'StudyActions';
  /** view/create/continue study consensus for this study */
  readonly compareUrl?: Maybe<Scalars['String']['output']>;
  /** edit study consensus for this study */
  readonly editCompareUrl?: Maybe<Scalars['String']['output']>;
  /** view/edit study extraction for this study */
  readonly extractUrl?: Maybe<Scalars['String']['output']>;
};

export type Note = Node & {
  readonly __typename: 'Note';
  readonly author: NoteAuthor;
  readonly createdAt: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly note: Scalars['String']['output'];
  readonly updatedAt: Scalars['String']['output'];
};

export type NoteAuthor = Node & {
  readonly __typename: 'NoteAuthor';
  readonly dbId: Scalars['ID']['output'];
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
  readonly primaryEmail: Scalars['Email']['output'];
};

export type ExtractionProgress = {
  readonly __typename: 'ExtractionProgress';
  readonly consensusSlot?: Maybe<ConsensusSlot>;
  readonly extractionSlots: ReadonlyArray<ExtractionSlot>;
  readonly status: ExtractionProgressStatus;
};

export type ConsensusSlot = {
  readonly __typename: 'ConsensusSlot';
  readonly assigned: Scalars['Boolean']['output'];
  readonly completed: Scalars['Boolean']['output'];
  readonly currentUser: Scalars['Boolean']['output'];
  readonly decider?: Maybe<ExtractionSlotUser>;
  readonly lastActivityAgo?: Maybe<Scalars['String']['output']>;
  readonly started: Scalars['Boolean']['output'];
};

export type ExtractionSlotUser = {
  readonly __typename: 'ExtractionSlotUser';
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
};

export type ExtractionSlot = {
  readonly __typename: 'ExtractionSlot';
  readonly assigned: Scalars['Boolean']['output'];
  readonly completed: Scalars['Boolean']['output'];
  readonly currentUser: Scalars['Boolean']['output'];
  readonly extractor?: Maybe<ExtractionSlotUser>;
  readonly lastActivityAgo?: Maybe<Scalars['String']['output']>;
};

export enum ExtractionProgressStatus {
  AwaitingTemplatePublication = 'AWAITING_TEMPLATE_PUBLICATION',
  Complete = 'COMPLETE',
  Consensus = 'CONSENSUS',
  Extraction = 'EXTRACTION',
  NotStarted = 'NOT_STARTED'
}

/** The connection type for Report. */
export type ReportConnection = {
  readonly __typename: 'ReportConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<ReportEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<Report>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly total: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ReportEdge = {
  readonly __typename: 'ReportEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<Report>;
};

export type Report = Node & ReferenceInterface & {
  readonly __typename: 'Report';
  /** The abstract of the report */
  readonly abstract?: Maybe<Scalars['String']['output']>;
  readonly authors: Scalars['String']['output'];
  /** Covidence Number of the associated review study */
  readonly covidenceNumber?: Maybe<Scalars['Int']['output']>;
  readonly documents?: Maybe<ReadonlyArray<Document>>;
  /** Digital Object Identifier */
  readonly doi?: Maybe<Scalars['String']['output']>;
  readonly fullText: Scalars['Boolean']['output'];
  readonly id: Scalars['ID']['output'];
  readonly journalInfo?: Maybe<Scalars['String']['output']>;
  readonly primaryAuthor: Scalars['String']['output'];
  /**
   * Details about the report publication. Most data in these fields is
   * unstructured (i.e. as it appears in source material) and therefore
   * typed as Strings even where another type might be appropriate.
   */
  readonly publication?: Maybe<Publication>;
  readonly publisherInfo?: Maybe<Scalars['String']['output']>;
  readonly referenceUrl?: Maybe<Scalars['String']['output']>;
  readonly source?: Maybe<Scalars['String']['output']>;
  readonly title?: Maybe<Scalars['String']['output']>;
};

export type Document = Node & {
  readonly __typename: 'Document';
  /** File name */
  readonly fileName?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly primaryDocument?: Maybe<Scalars['Boolean']['output']>;
  readonly url: Scalars['String']['output'];
};

/** The connection type for Import. */
export type ImportConnection = {
  readonly __typename: 'ImportConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<ImportEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<Import>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ImportEdge = {
  readonly __typename: 'ImportEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<Import>;
};

/** The connection type for Invite. */
export type InviteConnection = {
  readonly __typename: 'InviteConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<InviteEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<Invite>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly total: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type InviteEdge = {
  readonly __typename: 'InviteEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<Invite>;
};

export type Invite = Node & {
  readonly __typename: 'Invite';
  readonly accepted: Scalars['Boolean']['output'];
  readonly acceptedAt?: Maybe<Scalars['Time']['output']>;
  readonly createdAt: Scalars['Time']['output'];
  readonly declined: Scalars['Boolean']['output'];
  readonly declinedAt?: Maybe<Scalars['Time']['output']>;
  readonly email: Scalars['String']['output'];
  readonly expired: Scalars['Boolean']['output'];
  readonly expiresAt: Scalars['Time']['output'];
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
  readonly pending: Scalars['Boolean']['output'];
  readonly sentAt?: Maybe<Scalars['Time']['output']>;
};

/** The connection type for ReviewMembership. */
export type ReviewMembershipConnection = {
  readonly __typename: 'ReviewMembershipConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<ReviewMembershipEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<ReviewMembership>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly total: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ReviewMembershipEdge = {
  readonly __typename: 'ReviewMembershipEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<ReviewMembership>;
};

export type ReviewMembership = HasDuplicatesInterface & Node & {
  readonly __typename: 'ReviewMembership';
  readonly acceptedAt?: Maybe<Scalars['Time']['output']>;
  readonly canBeRemoved: Scalars['Boolean']['output'];
  readonly createdAt: Scalars['Time']['output'];
  readonly duplicates: DuplicateConnection;
  /** ID of the object. */
  readonly id: Scalars['ID']['output'];
  readonly isCurrentReviewer: Scalars['Boolean']['output'];
  readonly owner?: Maybe<Scalars['Boolean']['output']>;
  readonly reviewer: User;
};


export type ReviewMembershipDuplicatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reviewStudyId?: InputMaybe<Scalars['Int']['input']>;
};

export type StudiesFilter = {
  readonly author?: InputMaybe<Scalars['String']['input']>;
  readonly awaitingClassification?: InputMaybe<Scalars['Boolean']['input']>;
  readonly category?: InputMaybe<Category>;
  readonly covidenceNumber?: InputMaybe<Scalars['Int']['input']>;
  readonly ongoingStudy?: InputMaybe<Scalars['Boolean']['input']>;
  readonly title?: InputMaybe<Scalars['String']['input']>;
  readonly voteRequiredFrom?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum StudySort {
  Authors = 'AUTHORS',
  MostRecently = 'MOST_RECENTLY',
  MostRelevantAi = 'MOST_RELEVANT_AI',
  Relevancy = 'RELEVANCY',
  Title = 'TITLE'
}

/** The connection type for Study. */
export type StudyConnection = {
  readonly __typename: 'StudyConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<StudyEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<Study>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly total: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type StudyEdge = {
  readonly __typename: 'StudyEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<Study>;
};

export type Study = Node & {
  readonly __typename: 'Study';
  readonly authors?: Maybe<Scalars['String']['output']>;
  readonly awaitingClassification: Scalars['Boolean']['output'];
  readonly covidenceNumber: Scalars['Int']['output'];
  readonly displayTitle: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly notes: ReadonlyArray<Note>;
  readonly ongoingStudy: Scalars['Boolean']['output'];
  readonly pdfUrl?: Maybe<Scalars['String']['output']>;
  readonly references: ReportConnection;
  readonly studyId?: Maybe<Scalars['String']['output']>;
  readonly tags: ReadonlyArray<Scalars['String']['output']>;
  readonly title: Scalars['String']['output'];
  readonly votes: VoteConnection;
};


export type StudyReferencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type StudyVotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for Vote. */
export type VoteConnection = {
  readonly __typename: 'VoteConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<VoteEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<Vote>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly total: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type VoteEdge = {
  readonly __typename: 'VoteEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<Vote>;
};

export type Vote = Node & {
  readonly __typename: 'Vote';
  readonly consensus: Scalars['Boolean']['output'];
  readonly createdAt: Scalars['Time']['output'];
  readonly id: Scalars['ID']['output'];
  readonly reviewer: User;
  readonly studyCategory: Category;
  readonly vote: VoteValue;
};

export enum VoteValue {
  Exclude = 'EXCLUDE',
  Include = 'INCLUDE',
  Maybe = 'MAYBE',
  Merge = 'MERGE',
  No = 'NO',
  UndoCategory = 'UNDO_CATEGORY',
  UndoVote = 'UNDO_VOTE',
  Yes = 'YES'
}

export type Tag = Node & {
  readonly __typename: 'Tag';
  readonly id: Scalars['ID']['output'];
  readonly isDeleteable: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
};

export type CommentsFilter = {
  readonly restriction?: InputMaybe<CommentRestriction>;
  readonly scopeId: Scalars['ID']['input'];
  readonly status?: InputMaybe<CommentStatus>;
};

export enum CommentRestriction {
  All = 'ALL',
  Involved = 'INVOLVED'
}

export enum CommentStatus {
  Open = 'OPEN',
  Resolved = 'RESOLVED'
}

export enum CommentSort {
  RecentlyActive = 'RECENTLY_ACTIVE',
  RecentlyCreated = 'RECENTLY_CREATED',
  RecentlyResolved = 'RECENTLY_RESOLVED'
}

/** The connection type for Comment. */
export type CommentConnection = {
  readonly __typename: 'CommentConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<CommentEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<Comment>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly total: Scalars['Int']['output'];
  readonly totalOpen: Scalars['Int']['output'];
  readonly totalResolved: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CommentEdge = {
  readonly __typename: 'CommentEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<Comment>;
};

export type Comment = Node & {
  readonly __typename: 'Comment';
  readonly actions: CommentActions;
  readonly activeAgo: Scalars['String']['output'];
  readonly activeBy: User;
  readonly content: Scalars['String']['output'];
  readonly createdAgo: Scalars['String']['output'];
  readonly editedAgo?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly mentions: ReadonlyArray<CommentMention>;
  readonly replies?: Maybe<ReadonlyArray<Comment>>;
  readonly resolvedAgo?: Maybe<Scalars['String']['output']>;
  readonly reviewer: User;
  readonly reviewStudies: ReadonlyArray<Study>;
};

/** URLs for user actions that can be taken on this comment and urls for some. */
export type CommentActions = {
  readonly __typename: 'CommentActions';
  /** can the user edit the comment/reply */
  readonly canEdit?: Maybe<Scalars['Boolean']['output']>;
  /** can the user resolve the discussion */
  readonly canResolve?: Maybe<Scalars['Boolean']['output']>;
  /** view the comment in more detail */
  readonly showUrl?: Maybe<Scalars['String']['output']>;
};

export type CommentMention = {
  readonly __typename: 'CommentMention';
  /** mentioned user id */
  readonly id: Scalars['ID']['output'];
  /** mentioned user name */
  readonly name: Scalars['String']['output'];
  /** has the mentioned user replied to this comment */
  readonly replied: Scalars['Boolean']['output'];
};

/** The connection type for Guideline. */
export type GuidelineConnection = {
  readonly __typename: 'GuidelineConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<GuidelineEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<Guideline>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
};

/** An edge in a connection. */
export type GuidelineEdge = {
  readonly __typename: 'GuidelineEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<Guideline>;
};

export type Guideline = Node & {
  readonly __typename: 'Guideline';
  readonly actions: GuidelineActions;
  readonly createdAgo: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
  readonly topicExpertInvites?: Maybe<TopicExpertInviteConnection>;
  readonly topicExperts?: Maybe<TopicExpertConnection>;
  readonly topics?: Maybe<TopicConnection>;
};


export type GuidelineTopicExpertInvitesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type GuidelineTopicExpertsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type GuidelineTopicsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** URLs for user actions that can be taken on this guideline and urls for some. */
export type GuidelineActions = {
  readonly __typename: 'GuidelineActions';
  /** can the user invite topic experts */
  readonly canInviteTopicExpert: Scalars['Boolean']['output'];
  /** form to invite topic experts */
  readonly inviteTopicExpertUrl: Scalars['String']['output'];
};

/** The connection type for TopicExpertInvite. */
export type TopicExpertInviteConnection = {
  readonly __typename: 'TopicExpertInviteConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<TopicExpertInviteEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<TopicExpertInvite>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly total: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TopicExpertInviteEdge = {
  readonly __typename: 'TopicExpertInviteEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<TopicExpertInvite>;
};

export type TopicExpertInvite = Node & {
  readonly __typename: 'TopicExpertInvite';
  readonly accepted: Scalars['Boolean']['output'];
  readonly acceptedAt?: Maybe<Scalars['Time']['output']>;
  readonly createdAt: Scalars['Time']['output'];
  readonly declined: Scalars['Boolean']['output'];
  readonly declinedAt?: Maybe<Scalars['Time']['output']>;
  readonly email: Scalars['String']['output'];
  readonly expertTopics: ReadonlyArray<Topic>;
  readonly expired: Scalars['Boolean']['output'];
  readonly expiresAt: Scalars['Time']['output'];
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
  readonly pending: Scalars['Boolean']['output'];
};

export type Topic = Node & {
  readonly __typename: 'Topic';
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
};

/** The connection type for TopicExpert. */
export type TopicExpertConnection = {
  readonly __typename: 'TopicExpertConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<TopicExpertEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<TopicExpert>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
};

/** An edge in a connection. */
export type TopicExpertEdge = {
  readonly __typename: 'TopicExpertEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<TopicExpert>;
};

export type TopicExpert = Node & {
  readonly __typename: 'TopicExpert';
  readonly email: Scalars['String']['output'];
  readonly expertTopics: ReadonlyArray<Topic>;
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
};

/** The connection type for Topic. */
export type TopicConnection = {
  readonly __typename: 'TopicConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<TopicEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<Topic>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
};

/** An edge in a connection. */
export type TopicEdge = {
  readonly __typename: 'TopicEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<Topic>;
};

export type Mutation = {
  readonly __typename: 'Mutation';
  readonly addNoteToStudy?: Maybe<AddNoteToStudyPayload>;
  readonly addReplyToComment?: Maybe<AddReplyToCommentPayload>;
  readonly addTagsToStudies?: Maybe<AddTagsToStudiesPayload>;
  readonly addUploadedDocument?: Maybe<AddUploadedDocumentPayload>;
  /** (Re-)assign an administrator to a review owned by the specified organization */
  readonly assignOrganizationAdministratorToReview?: Maybe<AssignOrganizationAdministratorToReviewPayload>;
  readonly cancelInvitation?: Maybe<CancelInvitationPayload>;
  readonly cancelTopicExpertInvite?: Maybe<CancelTopicExpertInvitePayload>;
  readonly changeStudyIdentifier?: Maybe<ChangeStudyIdentifierPayload>;
  readonly completeConsensus?: Maybe<CompleteConsensusPayload>;
  readonly completeExtractedData?: Maybe<CompleteExtractedDataPayload>;
  readonly completeExtractionForm?: Maybe<CompleteExtractionFormPayload>;
  readonly createComment?: Maybe<CreateCommentPayload>;
  readonly createExtractionForm?: Maybe<CreateExtractionFormPayload>;
  readonly createExtractionFormRevision?: Maybe<CreateExtractionFormRevisionPayload>;
  readonly createLinkedCochraneReview?: Maybe<CreateLinkedCochraneReviewPayload>;
  readonly createReview?: Maybe<CreateReviewPayload>;
  readonly createTag?: Maybe<CreateTagPayload>;
  readonly deleteDocument?: Maybe<DeleteDocumentPayload>;
  readonly deleteTag?: Maybe<DeleteTagPayload>;
  readonly deleteTopicExpert?: Maybe<DeleteTopicExpertPayload>;
  readonly demoteOrganizationAdministratorToMember?: Maybe<DemoteOrganizationAdministratorToMemberPayload>;
  readonly denyMailingListConsent?: Maybe<DenyMailingListConsentPayload>;
  readonly editComment?: Maybe<EditCommentPayload>;
  readonly editNote?: Maybe<EditNotePayload>;
  readonly exportOrganizationAuthorList?: Maybe<ExportOrganizationAuthorListPayload>;
  readonly generateSignedUploadUrl?: Maybe<GenerateSignedUploadUrlPayload>;
  readonly grantMailingListConsent?: Maybe<GrantMailingListConsentPayload>;
  readonly initiateCrsImport?: Maybe<InitiateCrsImportPayload>;
  readonly invitePersonToOrganization?: Maybe<InvitePersonToOrganizationPayload>;
  readonly inviteTopicExpert?: Maybe<InviteTopicExpertPayload>;
  readonly markAsNotDuplicate?: Maybe<MarkAsNotDuplicatePayload>;
  readonly markDocumentAsPrimary?: Maybe<MarkDocumentAsPrimaryPayload>;
  readonly mergeStudies?: Maybe<MergeStudiesPayload>;
  readonly promoteOrganizationMemberToAdministrator?: Maybe<PromoteOrganizationMemberToAdministratorPayload>;
  readonly reassignStudyReviewer?: Maybe<ReassignStudyReviewerPayload>;
  readonly recordStudyVote?: Maybe<RecordStudyVotePayload>;
  readonly removeNote?: Maybe<RemoveNotePayload>;
  readonly removeReviewer?: Maybe<RemoveReviewerPayload>;
  readonly removeTagsFromStudies?: Maybe<RemoveTagsFromStudiesPayload>;
  readonly resendTopicExpertInvite?: Maybe<ResendTopicExpertInvitePayload>;
  readonly resolveDiscussion?: Maybe<ResolveDiscussionPayload>;
  readonly revertTemplate?: Maybe<RevertTemplatePayload>;
  readonly revokeMembership?: Maybe<RevokeMembershipPayload>;
  readonly saveConsensus?: Maybe<SaveConsensusPayload>;
  readonly saveExtractedData?: Maybe<SaveExtractedDataPayload>;
  /** Remove any administrator assignment for an organizational review */
  readonly unassignOrganizationAdministratorFromReview?: Maybe<UnassignOrganizationAdministratorFromReviewPayload>;
  readonly unmergeStudies?: Maybe<UnmergeStudiesPayload>;
};


export type MutationAddNoteToStudyArgs = {
  input: AddNoteToStudyInput;
};


export type MutationAddReplyToCommentArgs = {
  input: AddReplyToCommentInput;
};


export type MutationAddTagsToStudiesArgs = {
  input: AddTagsToStudiesInput;
};


export type MutationAddUploadedDocumentArgs = {
  input: AddUploadedDocumentInput;
};


export type MutationAssignOrganizationAdministratorToReviewArgs = {
  input: AssignOrganizationAdministratorToReviewInput;
};


export type MutationCancelInvitationArgs = {
  input: CancelInvitationInput;
};


export type MutationCancelTopicExpertInviteArgs = {
  input: CancelTopicExpertInviteInput;
};


export type MutationChangeStudyIdentifierArgs = {
  input: ChangeStudyIdentifierInput;
};


export type MutationCompleteConsensusArgs = {
  input: CompleteConsensusInput;
};


export type MutationCompleteExtractedDataArgs = {
  input: CompleteExtractedDataInput;
};


export type MutationCompleteExtractionFormArgs = {
  input: CompleteExtractionFormInput;
};


export type MutationCreateCommentArgs = {
  input: CreateCommentInput;
};


export type MutationCreateExtractionFormArgs = {
  input: CreateExtractionFormInput;
};


export type MutationCreateExtractionFormRevisionArgs = {
  input: CreateExtractionFormRevisionInput;
};


export type MutationCreateLinkedCochraneReviewArgs = {
  input: CreateLinkedCochraneReviewInput;
};


export type MutationCreateReviewArgs = {
  input: CreateReviewInput;
};


export type MutationCreateTagArgs = {
  input: CreateTagInput;
};


export type MutationDeleteDocumentArgs = {
  input: DeleteDocumentInput;
};


export type MutationDeleteTagArgs = {
  input: DeleteTagInput;
};


export type MutationDeleteTopicExpertArgs = {
  input: DeleteTopicExpertInput;
};


export type MutationDemoteOrganizationAdministratorToMemberArgs = {
  input: DemoteOrganizationAdministratorToMemberInput;
};


export type MutationDenyMailingListConsentArgs = {
  input: DenyMailingListConsentInput;
};


export type MutationEditCommentArgs = {
  input: EditCommentInput;
};


export type MutationEditNoteArgs = {
  input: EditNoteInput;
};


export type MutationExportOrganizationAuthorListArgs = {
  input: ExportOrganizationAuthorListInput;
};


export type MutationGenerateSignedUploadUrlArgs = {
  input: GenerateSignedUploadUrlInput;
};


export type MutationGrantMailingListConsentArgs = {
  input: GrantMailingListConsentInput;
};


export type MutationInitiateCrsImportArgs = {
  input: InitiateCrsImportInput;
};


export type MutationInvitePersonToOrganizationArgs = {
  input: InvitePersonToOrganizationInput;
};


export type MutationInviteTopicExpertArgs = {
  input: InviteTopicExpertInput;
};


export type MutationMarkAsNotDuplicateArgs = {
  input: MarkAsNotDuplicateInput;
};


export type MutationMarkDocumentAsPrimaryArgs = {
  input: MarkDocumentAsPrimaryInput;
};


export type MutationMergeStudiesArgs = {
  input: MergeStudiesInput;
};


export type MutationPromoteOrganizationMemberToAdministratorArgs = {
  input: PromoteOrganizationMemberToAdministratorInput;
};


export type MutationReassignStudyReviewerArgs = {
  input: ReassignStudyReviewerInput;
};


export type MutationRecordStudyVoteArgs = {
  input: RecordStudyVoteInput;
};


export type MutationRemoveNoteArgs = {
  input: RemoveNoteInput;
};


export type MutationRemoveReviewerArgs = {
  input: RemoveReviewerInput;
};


export type MutationRemoveTagsFromStudiesArgs = {
  input: RemoveTagsFromStudiesInput;
};


export type MutationResendTopicExpertInviteArgs = {
  input: ResendTopicExpertInviteInput;
};


export type MutationResolveDiscussionArgs = {
  input: ResolveDiscussionInput;
};


export type MutationRevertTemplateArgs = {
  input: RevertTemplateInput;
};


export type MutationRevokeMembershipArgs = {
  input: RevokeMembershipInput;
};


export type MutationSaveConsensusArgs = {
  input: SaveConsensusInput;
};


export type MutationSaveExtractedDataArgs = {
  input: SaveExtractedDataInput;
};


export type MutationUnassignOrganizationAdministratorFromReviewArgs = {
  input: UnassignOrganizationAdministratorFromReviewInput;
};


export type MutationUnmergeStudiesArgs = {
  input: UnmergeStudiesInput;
};

/** Autogenerated input type of AddNoteToStudy */
export type AddNoteToStudyInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly note: Scalars['String']['input'];
  readonly studyId: Scalars['ID']['input'];
};

/** Autogenerated return type of AddNoteToStudy */
export type AddNoteToStudyPayload = MutationResultInterface & {
  readonly __typename: 'AddNoteToStudyPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errors?: Maybe<ReadonlyArray<Error>>;
  readonly success: Scalars['Boolean']['output'];
};

export type MutationResultInterface = {
  readonly errors?: Maybe<ReadonlyArray<Error>>;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of AddReplyToComment */
export type AddReplyToCommentInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** the content of the reply */
  readonly content: Scalars['String']['input'];
  /** the id of the comment being replied to */
  readonly parentId: Scalars['ID']['input'];
};

/** Autogenerated return type of AddReplyToComment */
export type AddReplyToCommentPayload = MutationResultInterface & {
  readonly __typename: 'AddReplyToCommentPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errors?: Maybe<ReadonlyArray<Error>>;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of AddTagsToStudies */
export type AddTagsToStudiesInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly studyIds: ReadonlyArray<Scalars['ID']['input']>;
  readonly tags: ReadonlyArray<Scalars['String']['input']>;
};

/** Autogenerated return type of AddTagsToStudies */
export type AddTagsToStudiesPayload = MutationResultInterface & {
  readonly __typename: 'AddTagsToStudiesPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errors?: Maybe<ReadonlyArray<Error>>;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of AddUploadedDocument */
export type AddUploadedDocumentInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly filename: Scalars['String']['input'];
  readonly referenceId: Scalars['ID']['input'];
};

/** Autogenerated return type of AddUploadedDocument */
export type AddUploadedDocumentPayload = MutationResultInterface & {
  readonly __typename: 'AddUploadedDocumentPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly documents?: Maybe<ReadonlyArray<Document>>;
  readonly errors?: Maybe<ReadonlyArray<Error>>;
  readonly success: Scalars['Boolean']['output'];
  readonly url?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of AssignOrganizationAdministratorToReview */
export type AssignOrganizationAdministratorToReviewInput = {
  readonly administratorId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly reviewId: Scalars['ID']['input'];
};

/** Autogenerated return type of AssignOrganizationAdministratorToReview */
export type AssignOrganizationAdministratorToReviewPayload = MutationResultInterface & {
  readonly __typename: 'AssignOrganizationAdministratorToReviewPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errors?: Maybe<ReadonlyArray<Error>>;
  readonly organization?: Maybe<Organization>;
  readonly review?: Maybe<Review>;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CancelInvitation */
export type CancelInvitationInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly invitationId: Scalars['ID']['input'];
};

/** Autogenerated return type of CancelInvitation */
export type CancelInvitationPayload = MutationResultInterface & {
  readonly __typename: 'CancelInvitationPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errors?: Maybe<ReadonlyArray<Error>>;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CancelTopicExpertInvite */
export type CancelTopicExpertInviteInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** id of the invite */
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of CancelTopicExpertInvite */
export type CancelTopicExpertInvitePayload = MutationResultInterface & {
  readonly __typename: 'CancelTopicExpertInvitePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errors?: Maybe<ReadonlyArray<Error>>;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ChangeStudyIdentifier */
export type ChangeStudyIdentifierInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly newStudyIdentifier: Scalars['String']['input'];
  readonly studyId: Scalars['ID']['input'];
};

/** Autogenerated return type of ChangeStudyIdentifier */
export type ChangeStudyIdentifierPayload = MutationResultInterface & {
  readonly __typename: 'ChangeStudyIdentifierPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errors?: Maybe<ReadonlyArray<Error>>;
  readonly study?: Maybe<Study>;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CompleteConsensus */
export type CompleteConsensusInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly dataExtraction?: InputMaybe<CompleteConsensusFormInput>;
  readonly qualityAssessment?: InputMaybe<CompleteConsensusFormInput>;
  readonly studyId: Scalars['ID']['input'];
};

export type CompleteConsensusFormInput = {
  readonly data: Scalars['JSON']['input'];
  readonly sourceIds: ReadonlyArray<Scalars['ID']['input']>;
  readonly unresolvedFields?: InputMaybe<ReadonlyArray<UnresolvedFields>>;
};

export type UnresolvedFields = {
  readonly changedFields?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly reviewerId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of CompleteConsensus */
export type CompleteConsensusPayload = MutationResultInterface & {
  readonly __typename: 'CompleteConsensusPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly dataExtractionConsensusRevision?: Maybe<ConsensusRevision>;
  readonly errors?: Maybe<ReadonlyArray<Error>>;
  readonly qualityAssessmentConsensusRevision?: Maybe<ConsensusRevision>;
  readonly success: Scalars['Boolean']['output'];
};

export type ConsensusRevision = Node & {
  readonly __typename: 'ConsensusRevision';
  readonly consensus: Consensus;
  readonly data: Scalars['JSON']['output'];
  readonly id: Scalars['ID']['output'];
  readonly sources: ReadonlyArray<ExtractedDataRevision>;
  readonly study: Study;
};

export type Consensus = Node & {
  readonly __typename: 'Consensus';
  readonly currentRevision: ConsensusRevision;
  readonly decider: User;
  readonly extractionForm: ExtractionForm;
  readonly id: Scalars['ID']['output'];
  readonly review: Review;
  readonly revisions: ConsensusRevisionConnection;
  readonly study: Study;
};


export type ConsensusRevisionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for ConsensusRevision. */
export type ConsensusRevisionConnection = {
  readonly __typename: 'ConsensusRevisionConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<ConsensusRevisionEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<ConsensusRevision>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ConsensusRevisionEdge = {
  readonly __typename: 'ConsensusRevisionEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<ConsensusRevision>;
};

export type ExtractedDataRevision = Node & {
  readonly __typename: 'ExtractedDataRevision';
  readonly data: Scalars['JSON']['output'];
  readonly formRevision: ExtractionFormRevision;
  readonly id: Scalars['ID']['output'];
  readonly studyExtractor: StudyExtractor;
};

export type StudyExtractor = Node & {
  readonly __typename: 'StudyExtractor';
  readonly currentRevision: ExtractedDataRevision;
  readonly extractor: User;
  readonly form: ExtractionForm;
  readonly id: Scalars['ID']['output'];
  readonly revisions: ExtractedDataRevisionConnection;
  readonly study: Study;
};


export type StudyExtractorRevisionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for ExtractedDataRevision. */
export type ExtractedDataRevisionConnection = {
  readonly __typename: 'ExtractedDataRevisionConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<ExtractedDataRevisionEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<ExtractedDataRevision>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ExtractedDataRevisionEdge = {
  readonly __typename: 'ExtractedDataRevisionEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<ExtractedDataRevision>;
};

/** Autogenerated input type of CompleteExtractedData */
export type CompleteExtractedDataInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly dataExtraction?: InputMaybe<SaveFormExtractedDataInput>;
  readonly qualityAssessment?: InputMaybe<SaveFormExtractedDataInput>;
  readonly studyId: Scalars['ID']['input'];
};

export type SaveFormExtractedDataInput = {
  readonly data: Scalars['JSON']['input'];
  readonly formRevisionId: Scalars['ID']['input'];
};

/** Autogenerated return type of CompleteExtractedData */
export type CompleteExtractedDataPayload = MutationResultInterface & {
  readonly __typename: 'CompleteExtractedDataPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly dataExtractionRevision?: Maybe<ExtractedDataRevision>;
  readonly errors?: Maybe<ReadonlyArray<Error>>;
  readonly qualityAssessmentRevision?: Maybe<ExtractedDataRevision>;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CompleteExtractionForm */
export type CompleteExtractionFormInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly definition: Scalars['JSON']['input'];
  readonly extractionFormId?: InputMaybe<Scalars['ID']['input']>;
  readonly formType?: InputMaybe<Scalars['String']['input']>;
  readonly requiresRevisit?: InputMaybe<Scalars['Boolean']['input']>;
  readonly reviewerId?: InputMaybe<Scalars['ID']['input']>;
  readonly reviewId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of CompleteExtractionForm */
export type CompleteExtractionFormPayload = MutationResultInterface & {
  readonly __typename: 'CompleteExtractionFormPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errors?: Maybe<ReadonlyArray<Error>>;
  readonly extractionFormRevision: ExtractionFormRevision;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateComment */
export type CreateCommentInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** the content of the comment */
  readonly content: Scalars['String']['input'];
  /** the ids of the reviewers whose are mentioned in the comment */
  readonly mentionedReviewerIds: ReadonlyArray<Scalars['ID']['input']>;
  /** the ids of the studies being commented on */
  readonly studyIds: ReadonlyArray<Scalars['ID']['input']>;
};

/** Autogenerated return type of CreateComment */
export type CreateCommentPayload = MutationResultInterface & {
  readonly __typename: 'CreateCommentPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errors?: Maybe<ReadonlyArray<Error>>;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateExtractionForm */
export type CreateExtractionFormInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly definition: Scalars['JSON']['input'];
  readonly name: Scalars['String']['input'];
  readonly reviewId: Scalars['ID']['input'];
  readonly type: ExtractionFormType;
};

/** Autogenerated return type of CreateExtractionForm */
export type CreateExtractionFormPayload = MutationResultInterface & {
  readonly __typename: 'CreateExtractionFormPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errors?: Maybe<ReadonlyArray<Error>>;
  readonly form?: Maybe<ExtractionForm>;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateExtractionFormRevision */
export type CreateExtractionFormRevisionInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly definition: Scalars['JSON']['input'];
  readonly extractionFormId?: InputMaybe<Scalars['ID']['input']>;
  readonly formType?: InputMaybe<Scalars['String']['input']>;
  readonly reviewerId?: InputMaybe<Scalars['ID']['input']>;
  readonly reviewId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of CreateExtractionFormRevision */
export type CreateExtractionFormRevisionPayload = MutationResultInterface & {
  readonly __typename: 'CreateExtractionFormRevisionPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errors?: Maybe<ReadonlyArray<Error>>;
  readonly extractionFormRevision: ExtractionFormRevision;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateLinkedCochraneReview */
export type CreateLinkedCochraneReviewInput = {
  /** ID of the Account to which this review should be billed */
  readonly accountId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the Cochrane Review to which this new Covidence review should be linked */
  readonly cochraneReviewId: Scalars['ID']['input'];
  /** Option to enable RCT Auto Exclusion */
  readonly enableRctAutoExclusion?: InputMaybe<Scalars['Boolean']['input']>;
  /** Option to enable RCT classifier */
  readonly enableRctClassifier?: InputMaybe<Scalars['Boolean']['input']>;
  /** Option to enable extraction suggestions */
  readonly enableSuggestions?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether this is a main review or a practice review */
  readonly mainOrPractice: Scalars['String']['input'];
  /** Custom label if the primary purpose is other */
  readonly otherPrimaryPurposeLabel?: InputMaybe<Scalars['String']['input']>;
  /** The purpose of the review */
  readonly primaryPurpose: Scalars['String']['input'];
};

/** Autogenerated return type of CreateLinkedCochraneReview */
export type CreateLinkedCochraneReviewPayload = MutationResultInterface & {
  readonly __typename: 'CreateLinkedCochraneReviewPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errors?: Maybe<ReadonlyArray<Error>>;
  readonly review?: Maybe<Review>;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateReview */
export type CreateReviewInput = {
  /** ID of the Account to which this review should be billed */
  readonly accountId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Option to enable RCT Auto Exclusion if the area of research is medical and health sciences */
  readonly enableRctAutoExclusion?: InputMaybe<Scalars['Boolean']['input']>;
  /** Option to enable RCT classifier if the area of research is medical and health sciences */
  readonly enableRctClassifier?: InputMaybe<Scalars['Boolean']['input']>;
  /** Option to enable extraction suggestions */
  readonly enableSuggestions?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether this is a main review or a practice review */
  readonly mainOrPractice: Scalars['String']['input'];
  /** Custom label if the primary purpose is other */
  readonly otherPrimaryPurposeLabel?: InputMaybe<Scalars['String']['input']>;
  /** Custom label if the type of question is other */
  readonly otherQuestionTypeLabel?: InputMaybe<Scalars['String']['input']>;
  /** Custom label if the area of research is other */
  readonly otherResearchAreaLabel?: InputMaybe<Scalars['String']['input']>;
  /** Custom label if the type of review is other */
  readonly otherReviewTypeLabel?: InputMaybe<Scalars['String']['input']>;
  /** The purpose of the review */
  readonly primaryPurpose: Scalars['String']['input'];
  /** The type of question */
  readonly questionType: Scalars['String']['input'];
  /** The area of research */
  readonly researchArea: Scalars['String']['input'];
  /** The type of review */
  readonly reviewType: Scalars['String']['input'];
  /** A unique title for this review */
  readonly title: Scalars['String']['input'];
};

/** Autogenerated return type of CreateReview */
export type CreateReviewPayload = MutationResultInterface & {
  readonly __typename: 'CreateReviewPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errors?: Maybe<ReadonlyArray<Error>>;
  readonly review?: Maybe<Review>;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateTag */
export type CreateTagInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** A unique name within this review for the new Tag */
  readonly name: Scalars['String']['input'];
  /** ID of a Review to create the tag under */
  readonly reviewId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateTag */
export type CreateTagPayload = MutationResultInterface & {
  readonly __typename: 'CreateTagPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errors?: Maybe<ReadonlyArray<Error>>;
  readonly success: Scalars['Boolean']['output'];
  /** The newly created Tag */
  readonly tag?: Maybe<Tag>;
};

/** Autogenerated input type of DeleteDocument */
export type DeleteDocumentInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly documentId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteDocument */
export type DeleteDocumentPayload = MutationResultInterface & {
  readonly __typename: 'DeleteDocumentPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly documents: ReadonlyArray<Document>;
  readonly errors?: Maybe<ReadonlyArray<Error>>;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteTag */
export type DeleteTagInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of a Tag to delete */
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteTag */
export type DeleteTagPayload = MutationResultInterface & {
  readonly __typename: 'DeleteTagPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errors?: Maybe<ReadonlyArray<Error>>;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteTopicExpert */
export type DeleteTopicExpertInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** topic expert to delete */
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteTopicExpert */
export type DeleteTopicExpertPayload = MutationResultInterface & {
  readonly __typename: 'DeleteTopicExpertPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errors?: Maybe<ReadonlyArray<Error>>;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DemoteOrganizationAdministratorToMember */
export type DemoteOrganizationAdministratorToMemberInput = {
  readonly administratorId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly organizationId: Scalars['ID']['input'];
};

/** Autogenerated return type of DemoteOrganizationAdministratorToMember */
export type DemoteOrganizationAdministratorToMemberPayload = MutationResultInterface & {
  readonly __typename: 'DemoteOrganizationAdministratorToMemberPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errors?: Maybe<ReadonlyArray<Error>>;
  readonly membership?: Maybe<Membership>;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DenyMailingListConsent */
export type DenyMailingListConsentInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly signedSource: Scalars['String']['input'];
};

/** Autogenerated return type of DenyMailingListConsent */
export type DenyMailingListConsentPayload = MutationResultInterface & {
  readonly __typename: 'DenyMailingListConsentPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errors?: Maybe<ReadonlyArray<Error>>;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of EditComment */
export type EditCommentInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** the updated content */
  readonly content: Scalars['String']['input'];
  /** the id of the comment being edited */
  readonly existingCommentId: Scalars['ID']['input'];
};

/** Autogenerated return type of EditComment */
export type EditCommentPayload = MutationResultInterface & {
  readonly __typename: 'EditCommentPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errors?: Maybe<ReadonlyArray<Error>>;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of EditNote */
export type EditNoteInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly noteContent: Scalars['String']['input'];
  readonly noteId: Scalars['ID']['input'];
};

/** Autogenerated return type of EditNote */
export type EditNotePayload = MutationResultInterface & {
  readonly __typename: 'EditNotePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errors?: Maybe<ReadonlyArray<Error>>;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ExportOrganizationAuthorList */
export type ExportOrganizationAuthorListInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly filterAuthorsName?: InputMaybe<Scalars['String']['input']>;
  readonly organizationId: Scalars['ID']['input'];
  readonly sortDirection: SortDirection;
};

/** Autogenerated return type of ExportOrganizationAuthorList */
export type ExportOrganizationAuthorListPayload = MutationResultInterface & {
  readonly __typename: 'ExportOrganizationAuthorListPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errors?: Maybe<ReadonlyArray<Error>>;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of GenerateSignedUploadUrl */
export type GenerateSignedUploadUrlInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly filename: Scalars['String']['input'];
  readonly referenceId: Scalars['ID']['input'];
};

/** Autogenerated return type of GenerateSignedUploadUrl */
export type GenerateSignedUploadUrlPayload = MutationResultInterface & {
  readonly __typename: 'GenerateSignedUploadUrlPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errors?: Maybe<ReadonlyArray<Error>>;
  readonly success: Scalars['Boolean']['output'];
  readonly url?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of GrantMailingListConsent */
export type GrantMailingListConsentInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly signedSource: Scalars['String']['input'];
};

/** Autogenerated return type of GrantMailingListConsent */
export type GrantMailingListConsentPayload = MutationResultInterface & {
  readonly __typename: 'GrantMailingListConsentPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errors?: Maybe<ReadonlyArray<Error>>;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of InitiateCRSImport */
export type InitiateCrsImportInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly cochraneReviewLinkId: Scalars['ID']['input'];
};

/** Autogenerated return type of InitiateCRSImport */
export type InitiateCrsImportPayload = MutationResultInterface & {
  readonly __typename: 'InitiateCRSImportPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errors?: Maybe<ReadonlyArray<Error>>;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of InvitePersonToOrganization */
export type InvitePersonToOrganizationInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly email: Scalars['Email']['input'];
  readonly name: Scalars['String']['input'];
  readonly organizationId: Scalars['ID']['input'];
  readonly resend?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of InvitePersonToOrganization */
export type InvitePersonToOrganizationPayload = MutationResultInterface & {
  readonly __typename: 'InvitePersonToOrganizationPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errors?: Maybe<ReadonlyArray<Error>>;
  readonly invitation?: Maybe<Invitation>;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of InviteTopicExpert */
export type InviteTopicExpertInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** the email of invitee */
  readonly email: Scalars['String']['input'];
  /** the guideline to invite to */
  readonly guidelineId: Scalars['ID']['input'];
  /** the name of invitee */
  readonly name: Scalars['String']['input'];
  /** the ids of the topics they will be assigned to */
  readonly topicIds: ReadonlyArray<Scalars['ID']['input']>;
};

/** Autogenerated return type of InviteTopicExpert */
export type InviteTopicExpertPayload = MutationResultInterface & {
  readonly __typename: 'InviteTopicExpertPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errors?: Maybe<ReadonlyArray<Error>>;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of MarkAsNotDuplicate */
export type MarkAsNotDuplicateInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of a record which is considered a duplicate and conforms to the ReferenceInterface */
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of MarkAsNotDuplicate */
export type MarkAsNotDuplicatePayload = MutationResultInterface & {
  readonly __typename: 'MarkAsNotDuplicatePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errors?: Maybe<ReadonlyArray<Error>>;
  readonly originalCluster?: Maybe<DuplicateCluster>;
  readonly reference: ReferenceInterface;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of MarkDocumentAsPrimary */
export type MarkDocumentAsPrimaryInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly documentId: Scalars['ID']['input'];
};

/** Autogenerated return type of MarkDocumentAsPrimary */
export type MarkDocumentAsPrimaryPayload = MutationResultInterface & {
  readonly __typename: 'MarkDocumentAsPrimaryPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly documents: ReadonlyArray<Document>;
  readonly errors?: Maybe<ReadonlyArray<Error>>;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of MergeStudies */
export type MergeStudiesInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly desiredMasterStudyId: Scalars['ID']['input'];
  readonly studyIds: ReadonlyArray<Scalars['ID']['input']>;
};

/** Autogenerated return type of MergeStudies */
export type MergeStudiesPayload = MutationResultInterface & {
  readonly __typename: 'MergeStudiesPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errors?: Maybe<ReadonlyArray<Error>>;
  readonly studies?: Maybe<ReadonlyArray<Study>>;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of PromoteOrganizationMemberToAdministrator */
export type PromoteOrganizationMemberToAdministratorInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly memberId: Scalars['ID']['input'];
  readonly organizationId: Scalars['ID']['input'];
};

/** Autogenerated return type of PromoteOrganizationMemberToAdministrator */
export type PromoteOrganizationMemberToAdministratorPayload = MutationResultInterface & {
  readonly __typename: 'PromoteOrganizationMemberToAdministratorPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errors?: Maybe<ReadonlyArray<Error>>;
  readonly membership?: Maybe<Membership>;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ReassignStudyReviewer */
export type ReassignStudyReviewerInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly consensusReassignment?: InputMaybe<ConsensusReassignment>;
  readonly extractorReassignments?: InputMaybe<ReadonlyArray<InputMaybe<ExtractionReassignment>>>;
  readonly studyId: Scalars['ID']['input'];
};

export type ConsensusReassignment = {
  readonly preserveData: Scalars['Boolean']['input'];
  readonly reviewerId: Scalars['ID']['input'];
};

export type ExtractionReassignment = {
  readonly currentReviewerId: Scalars['ID']['input'];
  readonly newReviewerId: Scalars['ID']['input'];
  readonly preserveData: Scalars['Boolean']['input'];
};

/** Autogenerated return type of ReassignStudyReviewer */
export type ReassignStudyReviewerPayload = MutationResultInterface & {
  readonly __typename: 'ReassignStudyReviewerPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errors?: Maybe<ReadonlyArray<Error>>;
  readonly progress: ExtractionProgress;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of RecordStudyVote */
export type RecordStudyVoteInput = {
  readonly category?: InputMaybe<Category>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly exclusionReason?: InputMaybe<Scalars['String']['input']>;
  readonly studyId: Scalars['ID']['input'];
  readonly vote: VoteValue;
};

/** Autogenerated return type of RecordStudyVote */
export type RecordStudyVotePayload = MutationResultInterface & {
  readonly __typename: 'RecordStudyVotePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errors?: Maybe<ReadonlyArray<Error>>;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of RemoveNote */
export type RemoveNoteInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly noteId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveNote */
export type RemoveNotePayload = MutationResultInterface & {
  readonly __typename: 'RemoveNotePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errors?: Maybe<ReadonlyArray<Error>>;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of RemoveReviewer */
export type RemoveReviewerInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly reviewerId: Scalars['ID']['input'];
  readonly reviewId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveReviewer */
export type RemoveReviewerPayload = MutationResultInterface & {
  readonly __typename: 'RemoveReviewerPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errors?: Maybe<ReadonlyArray<Error>>;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of RemoveTagsFromStudies */
export type RemoveTagsFromStudiesInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly studyIds: ReadonlyArray<Scalars['ID']['input']>;
  readonly tags: ReadonlyArray<Scalars['String']['input']>;
};

/** Autogenerated return type of RemoveTagsFromStudies */
export type RemoveTagsFromStudiesPayload = MutationResultInterface & {
  readonly __typename: 'RemoveTagsFromStudiesPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errors?: Maybe<ReadonlyArray<Error>>;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ResendTopicExpertInvite */
export type ResendTopicExpertInviteInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** id of the invite */
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of ResendTopicExpertInvite */
export type ResendTopicExpertInvitePayload = MutationResultInterface & {
  readonly __typename: 'ResendTopicExpertInvitePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errors?: Maybe<ReadonlyArray<Error>>;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ResolveDiscussion */
export type ResolveDiscussionInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** the id of the comment being resolved */
  readonly commentId: Scalars['ID']['input'];
};

/** Autogenerated return type of ResolveDiscussion */
export type ResolveDiscussionPayload = MutationResultInterface & {
  readonly __typename: 'ResolveDiscussionPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errors?: Maybe<ReadonlyArray<Error>>;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of RevertTemplate */
export type RevertTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly templateId: Scalars['ID']['input'];
};

/** Autogenerated return type of RevertTemplate */
export type RevertTemplatePayload = MutationResultInterface & {
  readonly __typename: 'RevertTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errors?: Maybe<ReadonlyArray<Error>>;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of RevokeMembership */
export type RevokeMembershipInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly memberId: Scalars['ID']['input'];
  readonly organizationId: Scalars['ID']['input'];
};

/** Autogenerated return type of RevokeMembership */
export type RevokeMembershipPayload = MutationResultInterface & {
  readonly __typename: 'RevokeMembershipPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errors?: Maybe<ReadonlyArray<Error>>;
  readonly membership: Membership;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SaveConsensus */
export type SaveConsensusInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly dataExtraction?: InputMaybe<SaveConsensusFormInput>;
  readonly qualityAssessment?: InputMaybe<SaveConsensusFormInput>;
  readonly studyId: Scalars['ID']['input'];
};

export type SaveConsensusFormInput = {
  readonly data: Scalars['JSON']['input'];
  readonly sourceIds: ReadonlyArray<Scalars['ID']['input']>;
  readonly unresolvedFields?: InputMaybe<ReadonlyArray<UnresolvedFields>>;
};

/** Autogenerated return type of SaveConsensus */
export type SaveConsensusPayload = MutationResultInterface & {
  readonly __typename: 'SaveConsensusPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly dataExtractionConsensusRevision?: Maybe<ConsensusRevision>;
  readonly errors?: Maybe<ReadonlyArray<Error>>;
  readonly qualityAssessmentConsensusRevision?: Maybe<ConsensusRevision>;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SaveExtractedData */
export type SaveExtractedDataInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly dataExtraction?: InputMaybe<SaveFormExtractedDataInput>;
  readonly qualityAssessment?: InputMaybe<SaveFormExtractedDataInput>;
  readonly studyId: Scalars['ID']['input'];
};

/** Autogenerated return type of SaveExtractedData */
export type SaveExtractedDataPayload = MutationResultInterface & {
  readonly __typename: 'SaveExtractedDataPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly dataExtractionRevision?: Maybe<ExtractedDataRevision>;
  readonly errors?: Maybe<ReadonlyArray<Error>>;
  readonly qualityAssessmentRevision?: Maybe<ExtractedDataRevision>;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UnassignOrganizationAdministratorFromReview */
export type UnassignOrganizationAdministratorFromReviewInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly reviewId: Scalars['ID']['input'];
};

/** Autogenerated return type of UnassignOrganizationAdministratorFromReview */
export type UnassignOrganizationAdministratorFromReviewPayload = MutationResultInterface & {
  readonly __typename: 'UnassignOrganizationAdministratorFromReviewPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errors?: Maybe<ReadonlyArray<Error>>;
  readonly review?: Maybe<Review>;
  readonly success: Scalars['Boolean']['output'];
  /**
   * Returns the administrator, if any, who was assigned to the review before
   * this action
   */
  readonly unassignedAdministrator?: Maybe<User>;
};

/** Autogenerated input type of UnmergeStudies */
export type UnmergeStudiesInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly primaryStudyId: Scalars['ID']['input'];
};

/** Autogenerated return type of UnmergeStudies */
export type UnmergeStudiesPayload = MutationResultInterface & {
  readonly __typename: 'UnmergeStudiesPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errors?: Maybe<ReadonlyArray<Error>>;
  readonly success: Scalars['Boolean']['output'];
};

export type ReviewTagsQueryVariables = Exact<{
  reviewId: Scalars['ID']['input'];
}>;


export type ReviewTagsQuery = { readonly __typename: 'Query', readonly review?:
    | { readonly __typename: 'CochraneReview', readonly id: string }
    | { readonly __typename: 'CochraneReviewLink', readonly id: string }
    | { readonly __typename: 'Review', readonly id: string, readonly tags: ReadonlyArray<{ readonly __typename: 'Tag', readonly id: string, readonly isDeleteable: boolean, readonly name: string }> }
    | { readonly __typename: 'DuplicateCluster', readonly id: string }
    | { readonly __typename: 'User', readonly id: string }
    | { readonly __typename: 'Account', readonly id: string }
    | { readonly __typename: 'Organization', readonly id: string }
    | { readonly __typename: 'AuthorExport', readonly id: string }
    | { readonly __typename: 'Invitation', readonly id: string }
    | { readonly __typename: 'Membership', readonly id: string }
    | { readonly __typename: 'Import', readonly id: string }
    | { readonly __typename: 'ExtractionForm', readonly id: string }
    | { readonly __typename: 'ExtractionFormRevision', readonly id: string }
    | { readonly __typename: 'ExtractionStudy', readonly id: string }
    | { readonly __typename: 'Note', readonly id: string }
    | { readonly __typename: 'NoteAuthor', readonly id: string }
    | { readonly __typename: 'Report', readonly id: string }
    | { readonly __typename: 'Document', readonly id: string }
    | { readonly __typename: 'Invite', readonly id: string }
    | { readonly __typename: 'ReviewMembership', readonly id: string }
    | { readonly __typename: 'Study', readonly id: string }
    | { readonly __typename: 'Vote', readonly id: string }
    | { readonly __typename: 'Tag', readonly id: string }
    | { readonly __typename: 'Comment', readonly id: string }
    | { readonly __typename: 'Guideline', readonly id: string }
    | { readonly __typename: 'TopicExpertInvite', readonly id: string }
    | { readonly __typename: 'Topic', readonly id: string }
    | { readonly __typename: 'TopicExpert', readonly id: string }
    | { readonly __typename: 'ConsensusRevision', readonly id: string }
    | { readonly __typename: 'Consensus', readonly id: string }
    | { readonly __typename: 'ExtractedDataRevision', readonly id: string }
    | { readonly __typename: 'StudyExtractor', readonly id: string }
   | null };

export type CreateTagMutationVariables = Exact<{
  reviewId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}>;


export type CreateTagMutation = { readonly __typename: 'Mutation', readonly createTag?: { readonly __typename: 'CreateTagPayload', readonly success: boolean, readonly tag?: { readonly __typename: 'Tag', readonly id: string, readonly name: string, readonly isDeleteable: boolean } | null } | null };

export type DeleteTagMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteTagMutation = { readonly __typename: 'Mutation', readonly deleteTag?: { readonly __typename: 'DeleteTagPayload', readonly success: boolean } | null };

export type AdministratorsDataSourceQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdministratorsDataSourceQuery = { readonly __typename: 'Query', readonly organization?:
    | { readonly __typename: 'CochraneReview' }
    | { readonly __typename: 'CochraneReviewLink' }
    | { readonly __typename: 'Review' }
    | { readonly __typename: 'DuplicateCluster' }
    | { readonly __typename: 'User' }
    | { readonly __typename: 'Account' }
    | { readonly __typename: 'Organization', readonly administrators: { readonly __typename: 'UserConnection', readonly pageInfo: { readonly __typename: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly nodes?: ReadonlyArray<{ readonly __typename: 'User', readonly id: string, readonly name: string, readonly email: any, readonly organizationMembership: { readonly __typename: 'Membership', readonly assignedReviews: { readonly __typename: 'ReviewConnection', readonly total: number } } } | null> | null } }
    | { readonly __typename: 'AuthorExport' }
    | { readonly __typename: 'Invitation' }
    | { readonly __typename: 'Membership' }
    | { readonly __typename: 'Import' }
    | { readonly __typename: 'ExtractionForm' }
    | { readonly __typename: 'ExtractionFormRevision' }
    | { readonly __typename: 'ExtractionStudy' }
    | { readonly __typename: 'Note' }
    | { readonly __typename: 'NoteAuthor' }
    | { readonly __typename: 'Report' }
    | { readonly __typename: 'Document' }
    | { readonly __typename: 'Invite' }
    | { readonly __typename: 'ReviewMembership' }
    | { readonly __typename: 'Study' }
    | { readonly __typename: 'Vote' }
    | { readonly __typename: 'Tag' }
    | { readonly __typename: 'Comment' }
    | { readonly __typename: 'Guideline' }
    | { readonly __typename: 'TopicExpertInvite' }
    | { readonly __typename: 'Topic' }
    | { readonly __typename: 'TopicExpert' }
    | { readonly __typename: 'ConsensusRevision' }
    | { readonly __typename: 'Consensus' }
    | { readonly __typename: 'ExtractedDataRevision' }
    | { readonly __typename: 'StudyExtractor' }
   | null };

export type DemoteOrganizationAdministratorToMemberMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  administratorId: Scalars['ID']['input'];
}>;


export type DemoteOrganizationAdministratorToMemberMutation = { readonly __typename: 'Mutation', readonly demoteOrganizationAdministratorToMember?: { readonly __typename: 'DemoteOrganizationAdministratorToMemberPayload', readonly success: boolean, readonly errors?: ReadonlyArray<{ readonly __typename: 'Error', readonly message: string }> | null, readonly membership?: { readonly __typename: 'Membership', readonly id: string, readonly status: MembershipStatus } | null } | null };

export type PromoteOrganizationMemberToAdministratorMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  memberId: Scalars['ID']['input'];
}>;


export type PromoteOrganizationMemberToAdministratorMutation = { readonly __typename: 'Mutation', readonly promoteOrganizationMemberToAdministrator?: { readonly __typename: 'PromoteOrganizationMemberToAdministratorPayload', readonly success: boolean, readonly errors?: ReadonlyArray<{ readonly __typename: 'Error', readonly message: string }> | null, readonly membership?: { readonly __typename: 'Membership', readonly id: string, readonly status: MembershipStatus } | null } | null };

export type RevokeMembershipMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  memberId: Scalars['ID']['input'];
}>;


export type RevokeMembershipMutation = { readonly __typename: 'Mutation', readonly revokeMembership?: { readonly __typename: 'RevokeMembershipPayload', readonly success: boolean, readonly errors?: ReadonlyArray<{ readonly __typename: 'Error', readonly message: string }> | null, readonly membership: { readonly __typename: 'Membership', readonly id: string, readonly status: MembershipStatus, readonly memberSince?: any | null } } | null };

export type ReviewsFragment = { readonly __typename: 'Membership', readonly reviews?: { readonly __typename: 'ReviewConnection', readonly pageInfo: { readonly __typename: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly nodes?: ReadonlyArray<{ readonly __typename: 'Review', readonly id: string, readonly title: string, readonly lastActivityAt: any } | null> | null } | null };

export type GetReviewsQueryVariables = Exact<{
  authorId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetReviewsQuery = { readonly __typename: 'Query', readonly author?:
    | { readonly __typename: 'CochraneReview', readonly id: string }
    | { readonly __typename: 'CochraneReviewLink', readonly id: string }
    | { readonly __typename: 'Review', readonly id: string }
    | { readonly __typename: 'DuplicateCluster', readonly id: string }
    | { readonly __typename: 'User', readonly id: string, readonly membership: { readonly __typename: 'Membership', readonly id: string, readonly reviews?: { readonly __typename: 'ReviewConnection', readonly pageInfo: { readonly __typename: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly nodes?: ReadonlyArray<{ readonly __typename: 'Review', readonly id: string, readonly title: string, readonly lastActivityAt: any } | null> | null } | null } }
    | { readonly __typename: 'Account', readonly id: string }
    | { readonly __typename: 'Organization', readonly id: string }
    | { readonly __typename: 'AuthorExport', readonly id: string }
    | { readonly __typename: 'Invitation', readonly id: string }
    | { readonly __typename: 'Membership', readonly id: string }
    | { readonly __typename: 'Import', readonly id: string }
    | { readonly __typename: 'ExtractionForm', readonly id: string }
    | { readonly __typename: 'ExtractionFormRevision', readonly id: string }
    | { readonly __typename: 'ExtractionStudy', readonly id: string }
    | { readonly __typename: 'Note', readonly id: string }
    | { readonly __typename: 'NoteAuthor', readonly id: string }
    | { readonly __typename: 'Report', readonly id: string }
    | { readonly __typename: 'Document', readonly id: string }
    | { readonly __typename: 'Invite', readonly id: string }
    | { readonly __typename: 'ReviewMembership', readonly id: string }
    | { readonly __typename: 'Study', readonly id: string }
    | { readonly __typename: 'Vote', readonly id: string }
    | { readonly __typename: 'Tag', readonly id: string }
    | { readonly __typename: 'Comment', readonly id: string }
    | { readonly __typename: 'Guideline', readonly id: string }
    | { readonly __typename: 'TopicExpertInvite', readonly id: string }
    | { readonly __typename: 'Topic', readonly id: string }
    | { readonly __typename: 'TopicExpert', readonly id: string }
    | { readonly __typename: 'ConsensusRevision', readonly id: string }
    | { readonly __typename: 'Consensus', readonly id: string }
    | { readonly __typename: 'ExtractedDataRevision', readonly id: string }
    | { readonly __typename: 'StudyExtractor', readonly id: string }
   | null };

export type AssignedReviewsFragment = { readonly __typename: 'Membership', readonly assignedReviews: { readonly __typename: 'ReviewConnection', readonly pageInfo: { readonly __typename: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly nodes?: ReadonlyArray<{ readonly __typename: 'Review', readonly id: string, readonly title: string, readonly lastActivityAt: any } | null> | null } };

export type GetAssignedReviewsQueryVariables = Exact<{
  authorId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAssignedReviewsQuery = { readonly __typename: 'Query', readonly author?:
    | { readonly __typename: 'CochraneReview', readonly id: string }
    | { readonly __typename: 'CochraneReviewLink', readonly id: string }
    | { readonly __typename: 'Review', readonly id: string }
    | { readonly __typename: 'DuplicateCluster', readonly id: string }
    | { readonly __typename: 'User', readonly id: string, readonly membership: { readonly __typename: 'Membership', readonly id: string, readonly assignedReviews: { readonly __typename: 'ReviewConnection', readonly pageInfo: { readonly __typename: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly nodes?: ReadonlyArray<{ readonly __typename: 'Review', readonly id: string, readonly title: string, readonly lastActivityAt: any } | null> | null } } }
    | { readonly __typename: 'Account', readonly id: string }
    | { readonly __typename: 'Organization', readonly id: string }
    | { readonly __typename: 'AuthorExport', readonly id: string }
    | { readonly __typename: 'Invitation', readonly id: string }
    | { readonly __typename: 'Membership', readonly id: string }
    | { readonly __typename: 'Import', readonly id: string }
    | { readonly __typename: 'ExtractionForm', readonly id: string }
    | { readonly __typename: 'ExtractionFormRevision', readonly id: string }
    | { readonly __typename: 'ExtractionStudy', readonly id: string }
    | { readonly __typename: 'Note', readonly id: string }
    | { readonly __typename: 'NoteAuthor', readonly id: string }
    | { readonly __typename: 'Report', readonly id: string }
    | { readonly __typename: 'Document', readonly id: string }
    | { readonly __typename: 'Invite', readonly id: string }
    | { readonly __typename: 'ReviewMembership', readonly id: string }
    | { readonly __typename: 'Study', readonly id: string }
    | { readonly __typename: 'Vote', readonly id: string }
    | { readonly __typename: 'Tag', readonly id: string }
    | { readonly __typename: 'Comment', readonly id: string }
    | { readonly __typename: 'Guideline', readonly id: string }
    | { readonly __typename: 'TopicExpertInvite', readonly id: string }
    | { readonly __typename: 'Topic', readonly id: string }
    | { readonly __typename: 'TopicExpert', readonly id: string }
    | { readonly __typename: 'ConsensusRevision', readonly id: string }
    | { readonly __typename: 'Consensus', readonly id: string }
    | { readonly __typename: 'ExtractedDataRevision', readonly id: string }
    | { readonly __typename: 'StudyExtractor', readonly id: string }
   | null };

export type GetAuthorQueryVariables = Exact<{
  authorId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAuthorQuery = { readonly __typename: 'Query', readonly me?: { readonly __typename: 'User', readonly id: string } | null, readonly author?:
    | { readonly __typename: 'CochraneReview', readonly id: string }
    | { readonly __typename: 'CochraneReviewLink', readonly id: string }
    | { readonly __typename: 'Review', readonly id: string }
    | { readonly __typename: 'DuplicateCluster', readonly id: string }
    | { readonly __typename: 'User', readonly name: string, readonly id: string, readonly email: any, readonly membership: { readonly __typename: 'Membership', readonly id: string, readonly status: MembershipStatus, readonly invitation?: { readonly __typename: 'Invitation', readonly id: string, readonly email: any, readonly expiresAt: any } | null, readonly reviews?: { readonly __typename: 'ReviewConnection', readonly pageInfo: { readonly __typename: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly nodes?: ReadonlyArray<{ readonly __typename: 'Review', readonly id: string, readonly title: string, readonly lastActivityAt: any } | null> | null } | null, readonly assignedReviews: { readonly __typename: 'ReviewConnection', readonly pageInfo: { readonly __typename: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly nodes?: ReadonlyArray<{ readonly __typename: 'Review', readonly id: string, readonly title: string, readonly lastActivityAt: any } | null> | null } } }
    | { readonly __typename: 'Account', readonly id: string }
    | { readonly __typename: 'Organization', readonly id: string }
    | { readonly __typename: 'AuthorExport', readonly id: string }
    | { readonly __typename: 'Invitation', readonly id: string }
    | { readonly __typename: 'Membership', readonly id: string }
    | { readonly __typename: 'Import', readonly id: string }
    | { readonly __typename: 'ExtractionForm', readonly id: string }
    | { readonly __typename: 'ExtractionFormRevision', readonly id: string }
    | { readonly __typename: 'ExtractionStudy', readonly id: string }
    | { readonly __typename: 'Note', readonly id: string }
    | { readonly __typename: 'NoteAuthor', readonly id: string }
    | { readonly __typename: 'Report', readonly id: string }
    | { readonly __typename: 'Document', readonly id: string }
    | { readonly __typename: 'Invite', readonly id: string }
    | { readonly __typename: 'ReviewMembership', readonly id: string }
    | { readonly __typename: 'Study', readonly id: string }
    | { readonly __typename: 'Vote', readonly id: string }
    | { readonly __typename: 'Tag', readonly id: string }
    | { readonly __typename: 'Comment', readonly id: string }
    | { readonly __typename: 'Guideline', readonly id: string }
    | { readonly __typename: 'TopicExpertInvite', readonly id: string }
    | { readonly __typename: 'Topic', readonly id: string }
    | { readonly __typename: 'TopicExpert', readonly id: string }
    | { readonly __typename: 'ConsensusRevision', readonly id: string }
    | { readonly __typename: 'Consensus', readonly id: string }
    | { readonly __typename: 'ExtractedDataRevision', readonly id: string }
    | { readonly __typename: 'StudyExtractor', readonly id: string }
   | null, readonly organization?:
    | { readonly __typename: 'CochraneReview', readonly id: string }
    | { readonly __typename: 'CochraneReviewLink', readonly id: string }
    | { readonly __typename: 'Review', readonly id: string }
    | { readonly __typename: 'DuplicateCluster', readonly id: string }
    | { readonly __typename: 'User', readonly id: string }
    | { readonly __typename: 'Account', readonly id: string }
    | { readonly __typename: 'Organization', readonly name: string, readonly id: string }
    | { readonly __typename: 'AuthorExport', readonly id: string }
    | { readonly __typename: 'Invitation', readonly id: string }
    | { readonly __typename: 'Membership', readonly id: string }
    | { readonly __typename: 'Import', readonly id: string }
    | { readonly __typename: 'ExtractionForm', readonly id: string }
    | { readonly __typename: 'ExtractionFormRevision', readonly id: string }
    | { readonly __typename: 'ExtractionStudy', readonly id: string }
    | { readonly __typename: 'Note', readonly id: string }
    | { readonly __typename: 'NoteAuthor', readonly id: string }
    | { readonly __typename: 'Report', readonly id: string }
    | { readonly __typename: 'Document', readonly id: string }
    | { readonly __typename: 'Invite', readonly id: string }
    | { readonly __typename: 'ReviewMembership', readonly id: string }
    | { readonly __typename: 'Study', readonly id: string }
    | { readonly __typename: 'Vote', readonly id: string }
    | { readonly __typename: 'Tag', readonly id: string }
    | { readonly __typename: 'Comment', readonly id: string }
    | { readonly __typename: 'Guideline', readonly id: string }
    | { readonly __typename: 'TopicExpertInvite', readonly id: string }
    | { readonly __typename: 'Topic', readonly id: string }
    | { readonly __typename: 'TopicExpert', readonly id: string }
    | { readonly __typename: 'ConsensusRevision', readonly id: string }
    | { readonly __typename: 'Consensus', readonly id: string }
    | { readonly __typename: 'ExtractedDataRevision', readonly id: string }
    | { readonly __typename: 'StudyExtractor', readonly id: string }
   | null };

export type InvitationsQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type InvitationsQuery = { readonly __typename: 'Query', readonly organization?:
    | { readonly __typename: 'CochraneReview' }
    | { readonly __typename: 'CochraneReviewLink' }
    | { readonly __typename: 'Review' }
    | { readonly __typename: 'DuplicateCluster' }
    | { readonly __typename: 'User' }
    | { readonly __typename: 'Account' }
    | { readonly __typename: 'Organization', readonly invitations: { readonly __typename: 'InvitationConnection', readonly pageInfo: { readonly __typename: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly nodes?: ReadonlyArray<{ readonly __typename: 'Invitation', readonly id: string, readonly name?: string | null, readonly email: any, readonly expiresAt: any } | null> | null } }
    | { readonly __typename: 'AuthorExport' }
    | { readonly __typename: 'Invitation' }
    | { readonly __typename: 'Membership' }
    | { readonly __typename: 'Import' }
    | { readonly __typename: 'ExtractionForm' }
    | { readonly __typename: 'ExtractionFormRevision' }
    | { readonly __typename: 'ExtractionStudy' }
    | { readonly __typename: 'Note' }
    | { readonly __typename: 'NoteAuthor' }
    | { readonly __typename: 'Report' }
    | { readonly __typename: 'Document' }
    | { readonly __typename: 'Invite' }
    | { readonly __typename: 'ReviewMembership' }
    | { readonly __typename: 'Study' }
    | { readonly __typename: 'Vote' }
    | { readonly __typename: 'Tag' }
    | { readonly __typename: 'Comment' }
    | { readonly __typename: 'Guideline' }
    | { readonly __typename: 'TopicExpertInvite' }
    | { readonly __typename: 'Topic' }
    | { readonly __typename: 'TopicExpert' }
    | { readonly __typename: 'ConsensusRevision' }
    | { readonly __typename: 'Consensus' }
    | { readonly __typename: 'ExtractedDataRevision' }
    | { readonly __typename: 'StudyExtractor' }
   | null };

export type CancelInvitationMutationVariables = Exact<{
  invitationId: Scalars['ID']['input'];
}>;


export type CancelInvitationMutation = { readonly __typename: 'Mutation', readonly cancelInvitation?: { readonly __typename: 'CancelInvitationPayload', readonly success: boolean, readonly errors?: ReadonlyArray<{ readonly __typename: 'Error', readonly message: string }> | null } | null };

export type ExportOrganizationAuthorListMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  filterAuthorsName?: InputMaybe<Scalars['String']['input']>;
  sortDirection: SortDirection;
}>;


export type ExportOrganizationAuthorListMutation = { readonly __typename: 'Mutation', readonly exportOrganizationAuthorList?: { readonly __typename: 'ExportOrganizationAuthorListPayload', readonly success: boolean } | null };

export type AuthorsQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<OrganizationAuthorsFilter>;
  sort?: InputMaybe<UserSort>;
  sortDirection?: InputMaybe<SortDirection>;
}>;


export type AuthorsQuery = { readonly __typename: 'Query', readonly organization?:
    | { readonly __typename: 'CochraneReview', readonly id: string }
    | { readonly __typename: 'CochraneReviewLink', readonly id: string }
    | { readonly __typename: 'Review', readonly id: string }
    | { readonly __typename: 'DuplicateCluster', readonly id: string }
    | { readonly __typename: 'User', readonly id: string }
    | { readonly __typename: 'Account', readonly id: string }
    | { readonly __typename: 'Organization', readonly id: string, readonly authors: { readonly __typename: 'UserConnection', readonly pageInfo: { readonly __typename: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly nodes?: ReadonlyArray<{ readonly __typename: 'User', readonly id: string, readonly name: string, readonly email: any, readonly membership: { readonly __typename: 'Membership', readonly id: string, readonly status: MembershipStatus, readonly memberSince?: any | null, readonly organizationReviews?: { readonly __typename: 'ReviewConnection', readonly total: number } | null } } | null> | null } }
    | { readonly __typename: 'AuthorExport', readonly id: string }
    | { readonly __typename: 'Invitation', readonly id: string }
    | { readonly __typename: 'Membership', readonly id: string }
    | { readonly __typename: 'Import', readonly id: string }
    | { readonly __typename: 'ExtractionForm', readonly id: string }
    | { readonly __typename: 'ExtractionFormRevision', readonly id: string }
    | { readonly __typename: 'ExtractionStudy', readonly id: string }
    | { readonly __typename: 'Note', readonly id: string }
    | { readonly __typename: 'NoteAuthor', readonly id: string }
    | { readonly __typename: 'Report', readonly id: string }
    | { readonly __typename: 'Document', readonly id: string }
    | { readonly __typename: 'Invite', readonly id: string }
    | { readonly __typename: 'ReviewMembership', readonly id: string }
    | { readonly __typename: 'Study', readonly id: string }
    | { readonly __typename: 'Vote', readonly id: string }
    | { readonly __typename: 'Tag', readonly id: string }
    | { readonly __typename: 'Comment', readonly id: string }
    | { readonly __typename: 'Guideline', readonly id: string }
    | { readonly __typename: 'TopicExpertInvite', readonly id: string }
    | { readonly __typename: 'Topic', readonly id: string }
    | { readonly __typename: 'TopicExpert', readonly id: string }
    | { readonly __typename: 'ConsensusRevision', readonly id: string }
    | { readonly __typename: 'Consensus', readonly id: string }
    | { readonly __typename: 'ExtractedDataRevision', readonly id: string }
    | { readonly __typename: 'StudyExtractor', readonly id: string }
   | null };

export type InvitePersonToOrganizationMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  email: Scalars['Email']['input'];
  resend?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type InvitePersonToOrganizationMutation = { readonly __typename: 'Mutation', readonly invitePersonToOrganization?: { readonly __typename: 'InvitePersonToOrganizationPayload', readonly success: boolean, readonly errors?: ReadonlyArray<{ readonly __typename: 'Error', readonly message: string }> | null, readonly invitation?: { readonly __typename: 'Invitation', readonly id: string, readonly name?: string | null, readonly email: any, readonly expiresAt: any } | null } | null };

export type GetAuthorsExportQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type GetAuthorsExportQuery = { readonly __typename: 'Query', readonly organization?:
    | { readonly __typename: 'CochraneReview' }
    | { readonly __typename: 'CochraneReviewLink' }
    | { readonly __typename: 'Review' }
    | { readonly __typename: 'DuplicateCluster' }
    | { readonly __typename: 'User' }
    | { readonly __typename: 'Account' }
    | { readonly __typename: 'Organization', readonly exports?: ReadonlyArray<{ readonly __typename: 'AuthorExport', readonly id: string, readonly authenticatedUrl?: string | null, readonly createdAt: string, readonly completedAt?: string | null, readonly failed: boolean }> | null }
    | { readonly __typename: 'AuthorExport' }
    | { readonly __typename: 'Invitation' }
    | { readonly __typename: 'Membership' }
    | { readonly __typename: 'Import' }
    | { readonly __typename: 'ExtractionForm' }
    | { readonly __typename: 'ExtractionFormRevision' }
    | { readonly __typename: 'ExtractionStudy' }
    | { readonly __typename: 'Note' }
    | { readonly __typename: 'NoteAuthor' }
    | { readonly __typename: 'Report' }
    | { readonly __typename: 'Document' }
    | { readonly __typename: 'Invite' }
    | { readonly __typename: 'ReviewMembership' }
    | { readonly __typename: 'Study' }
    | { readonly __typename: 'Vote' }
    | { readonly __typename: 'Tag' }
    | { readonly __typename: 'Comment' }
    | { readonly __typename: 'Guideline' }
    | { readonly __typename: 'TopicExpertInvite' }
    | { readonly __typename: 'Topic' }
    | { readonly __typename: 'TopicExpert' }
    | { readonly __typename: 'ConsensusRevision' }
    | { readonly __typename: 'Consensus' }
    | { readonly __typename: 'ExtractedDataRevision' }
    | { readonly __typename: 'StudyExtractor' }
   | null };

export type AssignAdminMutationVariables = Exact<{
  reviewId: Scalars['ID']['input'];
  administratorId: Scalars['ID']['input'];
}>;


export type AssignAdminMutation = { readonly __typename: 'Mutation', readonly assign?: { readonly __typename: 'AssignOrganizationAdministratorToReviewPayload', readonly success: boolean, readonly review?: { readonly __typename: 'Review', readonly id: string, readonly assignedAdministrator?: { readonly __typename: 'User', readonly id: string, readonly name: string, readonly email: any } | null } | null, readonly errors?: ReadonlyArray<{ readonly __typename: 'Error', readonly message: string }> | null } | null };

export type UnassignAdminMutationVariables = Exact<{
  reviewId: Scalars['ID']['input'];
}>;


export type UnassignAdminMutation = { readonly __typename: 'Mutation', readonly assign?: { readonly __typename: 'UnassignOrganizationAdministratorFromReviewPayload', readonly success: boolean, readonly review?: { readonly __typename: 'Review', readonly id: string, readonly assignedAdministrator?: { readonly __typename: 'User', readonly id: string, readonly name: string, readonly email: any } | null } | null, readonly errors?: ReadonlyArray<{ readonly __typename: 'Error', readonly message: string }> | null } | null };

export type AdministratorFragment = { readonly __typename: 'User', readonly id: string, readonly name: string, readonly email: any };

export type AdministratorsQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type AdministratorsQuery = { readonly __typename: 'Query', readonly organization?:
    | { readonly __typename: 'CochraneReview' }
    | { readonly __typename: 'CochraneReviewLink' }
    | { readonly __typename: 'Review' }
    | { readonly __typename: 'DuplicateCluster' }
    | { readonly __typename: 'User' }
    | { readonly __typename: 'Account' }
    | { readonly __typename: 'Organization', readonly administrators: { readonly __typename: 'UserConnection', readonly nodes?: ReadonlyArray<{ readonly __typename: 'User', readonly id: string, readonly name: string, readonly email: any } | null> | null } }
    | { readonly __typename: 'AuthorExport' }
    | { readonly __typename: 'Invitation' }
    | { readonly __typename: 'Membership' }
    | { readonly __typename: 'Import' }
    | { readonly __typename: 'ExtractionForm' }
    | { readonly __typename: 'ExtractionFormRevision' }
    | { readonly __typename: 'ExtractionStudy' }
    | { readonly __typename: 'Note' }
    | { readonly __typename: 'NoteAuthor' }
    | { readonly __typename: 'Report' }
    | { readonly __typename: 'Document' }
    | { readonly __typename: 'Invite' }
    | { readonly __typename: 'ReviewMembership' }
    | { readonly __typename: 'Study' }
    | { readonly __typename: 'Vote' }
    | { readonly __typename: 'Tag' }
    | { readonly __typename: 'Comment' }
    | { readonly __typename: 'Guideline' }
    | { readonly __typename: 'TopicExpertInvite' }
    | { readonly __typename: 'Topic' }
    | { readonly __typename: 'TopicExpert' }
    | { readonly __typename: 'ConsensusRevision' }
    | { readonly __typename: 'Consensus' }
    | { readonly __typename: 'ExtractedDataRevision' }
    | { readonly __typename: 'StudyExtractor' }
   | null };

export type ReviewsQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<OrganizationReviewsFilter>;
  sort?: InputMaybe<ReviewSort>;
  sortDirection?: InputMaybe<SortDirection>;
}>;


export type ReviewsQuery = { readonly __typename: 'Query', readonly organization?:
    | { readonly __typename: 'CochraneReview' }
    | { readonly __typename: 'CochraneReviewLink' }
    | { readonly __typename: 'Review' }
    | { readonly __typename: 'DuplicateCluster' }
    | { readonly __typename: 'User' }
    | { readonly __typename: 'Account' }
    | { readonly __typename: 'Organization', readonly reviews: { readonly __typename: 'ReviewConnection', readonly pageInfo: { readonly __typename: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly nodes?: ReadonlyArray<{ readonly __typename: 'Review', readonly id: string, readonly title: string, readonly lastActivityAt: any, readonly collaborators: { readonly __typename: 'UserConnection', readonly total: number }, readonly assignedAdministrator?: { readonly __typename: 'User', readonly id: string, readonly name: string } | null } | null> | null } }
    | { readonly __typename: 'AuthorExport' }
    | { readonly __typename: 'Invitation' }
    | { readonly __typename: 'Membership' }
    | { readonly __typename: 'Import' }
    | { readonly __typename: 'ExtractionForm' }
    | { readonly __typename: 'ExtractionFormRevision' }
    | { readonly __typename: 'ExtractionStudy' }
    | { readonly __typename: 'Note' }
    | { readonly __typename: 'NoteAuthor' }
    | { readonly __typename: 'Report' }
    | { readonly __typename: 'Document' }
    | { readonly __typename: 'Invite' }
    | { readonly __typename: 'ReviewMembership' }
    | { readonly __typename: 'Study' }
    | { readonly __typename: 'Vote' }
    | { readonly __typename: 'Tag' }
    | { readonly __typename: 'Comment' }
    | { readonly __typename: 'Guideline' }
    | { readonly __typename: 'TopicExpertInvite' }
    | { readonly __typename: 'Topic' }
    | { readonly __typename: 'TopicExpert' }
    | { readonly __typename: 'ConsensusRevision' }
    | { readonly __typename: 'Consensus' }
    | { readonly __typename: 'ExtractedDataRevision' }
    | { readonly __typename: 'StudyExtractor' }
   | null };

export type GrantMailingListConsentMutationVariables = Exact<{
  signedSource: Scalars['String']['input'];
}>;


export type GrantMailingListConsentMutation = { readonly __typename: 'Mutation', readonly saveConsent?: { readonly __typename: 'GrantMailingListConsentPayload', readonly success: boolean, readonly errors?: ReadonlyArray<{ readonly __typename: 'Error', readonly code: string, readonly message: string }> | null } | null };

export type DenyMailingListConsentMutationVariables = Exact<{
  signedSource: Scalars['String']['input'];
}>;


export type DenyMailingListConsentMutation = { readonly __typename: 'Mutation', readonly saveConsent?: { readonly __typename: 'DenyMailingListConsentPayload', readonly success: boolean, readonly errors?: ReadonlyArray<{ readonly __typename: 'Error', readonly code: string, readonly message: string }> | null } | null };

export type ProfileDataQueryVariables = Exact<{ [key: string]: never; }>;


export type ProfileDataQuery = { readonly __typename: 'Query', readonly me?: { readonly __typename: 'User', readonly consent: { readonly __typename: 'UserConsent', readonly decision: UserConsentDecision } } | null };

export type AdminOrganizationInvitationsQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<OrganizationInvitationsFilter>;
}>;


export type AdminOrganizationInvitationsQuery = { readonly __typename: 'Query', readonly organization?:
    | { readonly __typename: 'CochraneReview', readonly id: string }
    | { readonly __typename: 'CochraneReviewLink', readonly id: string }
    | { readonly __typename: 'Review', readonly id: string }
    | { readonly __typename: 'DuplicateCluster', readonly id: string }
    | { readonly __typename: 'User', readonly id: string }
    | { readonly __typename: 'Account', readonly id: string }
    | { readonly __typename: 'Organization', readonly id: string, readonly invitations: { readonly __typename: 'InvitationConnection', readonly pageInfo: { readonly __typename: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly nodes?: ReadonlyArray<{ readonly __typename: 'Invitation', readonly id: string, readonly email: any, readonly name?: string | null, readonly expiresAt: any } | null> | null } }
    | { readonly __typename: 'AuthorExport', readonly id: string }
    | { readonly __typename: 'Invitation', readonly id: string }
    | { readonly __typename: 'Membership', readonly id: string }
    | { readonly __typename: 'Import', readonly id: string }
    | { readonly __typename: 'ExtractionForm', readonly id: string }
    | { readonly __typename: 'ExtractionFormRevision', readonly id: string }
    | { readonly __typename: 'ExtractionStudy', readonly id: string }
    | { readonly __typename: 'Note', readonly id: string }
    | { readonly __typename: 'NoteAuthor', readonly id: string }
    | { readonly __typename: 'Report', readonly id: string }
    | { readonly __typename: 'Document', readonly id: string }
    | { readonly __typename: 'Invite', readonly id: string }
    | { readonly __typename: 'ReviewMembership', readonly id: string }
    | { readonly __typename: 'Study', readonly id: string }
    | { readonly __typename: 'Vote', readonly id: string }
    | { readonly __typename: 'Tag', readonly id: string }
    | { readonly __typename: 'Comment', readonly id: string }
    | { readonly __typename: 'Guideline', readonly id: string }
    | { readonly __typename: 'TopicExpertInvite', readonly id: string }
    | { readonly __typename: 'Topic', readonly id: string }
    | { readonly __typename: 'TopicExpert', readonly id: string }
    | { readonly __typename: 'ConsensusRevision', readonly id: string }
    | { readonly __typename: 'Consensus', readonly id: string }
    | { readonly __typename: 'ExtractedDataRevision', readonly id: string }
    | { readonly __typename: 'StudyExtractor', readonly id: string }
   | null };

export type AdminDeleteOrganizationInvitationMutationVariables = Exact<{
  invitationId: Scalars['ID']['input'];
}>;


export type AdminDeleteOrganizationInvitationMutation = { readonly __typename: 'Mutation', readonly cancelInvitation?: { readonly __typename: 'CancelInvitationPayload', readonly success: boolean, readonly errors?: ReadonlyArray<{ readonly __typename: 'Error', readonly message: string }> | null } | null };

export type AdminResendOrganizationInvitationMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  email: Scalars['Email']['input'];
}>;


export type AdminResendOrganizationInvitationMutation = { readonly __typename: 'Mutation', readonly invitePersonToOrganization?: { readonly __typename: 'InvitePersonToOrganizationPayload', readonly success: boolean, readonly errors?: ReadonlyArray<{ readonly __typename: 'Error', readonly message: string }> | null, readonly invitation?: { readonly __typename: 'Invitation', readonly id: string, readonly name?: string | null, readonly email: any, readonly expiresAt: any } | null } | null };

export type AdminOrganizationMembersQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<OrganizationMembershipsFilter>;
}>;


export type AdminOrganizationMembersQuery = { readonly __typename: 'Query', readonly organization?:
    | { readonly __typename: 'CochraneReview', readonly id: string }
    | { readonly __typename: 'CochraneReviewLink', readonly id: string }
    | { readonly __typename: 'Review', readonly id: string }
    | { readonly __typename: 'DuplicateCluster', readonly id: string }
    | { readonly __typename: 'User', readonly id: string }
    | { readonly __typename: 'Account', readonly id: string }
    | { readonly __typename: 'Organization', readonly id: string, readonly memberships: { readonly __typename: 'MembershipConnection', readonly pageInfo: { readonly __typename: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly nodes?: ReadonlyArray<{ readonly __typename: 'Membership', readonly id: string, readonly status: MembershipStatus, readonly memberSince?: any | null, readonly member: { readonly __typename: 'User', readonly dbId: string, readonly id: string, readonly name: string } } | null> | null } }
    | { readonly __typename: 'AuthorExport', readonly id: string }
    | { readonly __typename: 'Invitation', readonly id: string }
    | { readonly __typename: 'Membership', readonly id: string }
    | { readonly __typename: 'Import', readonly id: string }
    | { readonly __typename: 'ExtractionForm', readonly id: string }
    | { readonly __typename: 'ExtractionFormRevision', readonly id: string }
    | { readonly __typename: 'ExtractionStudy', readonly id: string }
    | { readonly __typename: 'Note', readonly id: string }
    | { readonly __typename: 'NoteAuthor', readonly id: string }
    | { readonly __typename: 'Report', readonly id: string }
    | { readonly __typename: 'Document', readonly id: string }
    | { readonly __typename: 'Invite', readonly id: string }
    | { readonly __typename: 'ReviewMembership', readonly id: string }
    | { readonly __typename: 'Study', readonly id: string }
    | { readonly __typename: 'Vote', readonly id: string }
    | { readonly __typename: 'Tag', readonly id: string }
    | { readonly __typename: 'Comment', readonly id: string }
    | { readonly __typename: 'Guideline', readonly id: string }
    | { readonly __typename: 'TopicExpertInvite', readonly id: string }
    | { readonly __typename: 'Topic', readonly id: string }
    | { readonly __typename: 'TopicExpert', readonly id: string }
    | { readonly __typename: 'ConsensusRevision', readonly id: string }
    | { readonly __typename: 'Consensus', readonly id: string }
    | { readonly __typename: 'ExtractedDataRevision', readonly id: string }
    | { readonly __typename: 'StudyExtractor', readonly id: string }
   | null };

export type AdminRevokeMembershipMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  memberId: Scalars['ID']['input'];
}>;


export type AdminRevokeMembershipMutation = { readonly __typename: 'Mutation', readonly revokeMembership?: { readonly __typename: 'RevokeMembershipPayload', readonly success: boolean, readonly errors?: ReadonlyArray<{ readonly __typename: 'Error', readonly message: string }> | null } | null };

export type AdminPromoteOrganizationMemberMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  memberId: Scalars['ID']['input'];
}>;


export type AdminPromoteOrganizationMemberMutation = { readonly __typename: 'Mutation', readonly promoteOrganizationMemberToAdministrator?: { readonly __typename: 'PromoteOrganizationMemberToAdministratorPayload', readonly success: boolean, readonly errors?: ReadonlyArray<{ readonly __typename: 'Error', readonly message: string }> | null, readonly membership?: { readonly __typename: 'Membership', readonly id: string, readonly status: MembershipStatus } | null } | null };

export type AdminDemoteOrganizationMemberMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  memberId: Scalars['ID']['input'];
}>;


export type AdminDemoteOrganizationMemberMutation = { readonly __typename: 'Mutation', readonly demoteOrganizationAdministratorToMember?: { readonly __typename: 'DemoteOrganizationAdministratorToMemberPayload', readonly success: boolean, readonly errors?: ReadonlyArray<{ readonly __typename: 'Error', readonly message: string }> | null, readonly membership?: { readonly __typename: 'Membership', readonly id: string, readonly status: MembershipStatus } | null } | null };

export type AdminAccountReviewsQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<OrganizationReviewsFilter>;
  sort?: InputMaybe<ReviewSort>;
  sortDirection?: InputMaybe<SortDirection>;
}>;


export type AdminAccountReviewsQuery = { readonly __typename: 'Query', readonly organization?:
    | { readonly __typename: 'CochraneReview' }
    | { readonly __typename: 'CochraneReviewLink' }
    | { readonly __typename: 'Review' }
    | { readonly __typename: 'DuplicateCluster' }
    | { readonly __typename: 'User' }
    | { readonly __typename: 'Account' }
    | { readonly __typename: 'Organization', readonly id: string, readonly reviews: { readonly __typename: 'ReviewConnection', readonly pageInfo: { readonly __typename: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly nodes?: ReadonlyArray<{ readonly __typename: 'Review', readonly id: string, readonly dbId: string, readonly title: string, readonly lastActivityAt: any, readonly createdAt: any, readonly deletedAt?: any | null, readonly creator: { readonly __typename: 'User', readonly id: string, readonly dbId: string, readonly name: string }, readonly cochraneReviewLink?: { readonly __typename: 'CochraneReviewLink', readonly id: string } | null } | null> | null } }
    | { readonly __typename: 'AuthorExport' }
    | { readonly __typename: 'Invitation' }
    | { readonly __typename: 'Membership' }
    | { readonly __typename: 'Import' }
    | { readonly __typename: 'ExtractionForm' }
    | { readonly __typename: 'ExtractionFormRevision' }
    | { readonly __typename: 'ExtractionStudy' }
    | { readonly __typename: 'Note' }
    | { readonly __typename: 'NoteAuthor' }
    | { readonly __typename: 'Report' }
    | { readonly __typename: 'Document' }
    | { readonly __typename: 'Invite' }
    | { readonly __typename: 'ReviewMembership' }
    | { readonly __typename: 'Study' }
    | { readonly __typename: 'Vote' }
    | { readonly __typename: 'Tag' }
    | { readonly __typename: 'Comment' }
    | { readonly __typename: 'Guideline' }
    | { readonly __typename: 'TopicExpertInvite' }
    | { readonly __typename: 'Topic' }
    | { readonly __typename: 'TopicExpert' }
    | { readonly __typename: 'ConsensusRevision' }
    | { readonly __typename: 'Consensus' }
    | { readonly __typename: 'ExtractedDataRevision' }
    | { readonly __typename: 'StudyExtractor' }
   | null };

export type AccountReviewsFragment = { readonly __typename: 'ReviewConnection', readonly pageInfo: { readonly __typename: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly nodes?: ReadonlyArray<{ readonly __typename: 'Review', readonly id: string, readonly dbId: string, readonly title: string, readonly lastActivityAt: any, readonly createdAt: any, readonly deletedAt?: any | null, readonly creator: { readonly __typename: 'User', readonly id: string, readonly dbId: string, readonly name: string }, readonly cochraneReviewLink?: { readonly __typename: 'CochraneReviewLink', readonly id: string } | null } | null> | null };

export type ChangeStudyIdentifierMutationVariables = Exact<{
  studyId: Scalars['ID']['input'];
  newStudyIdentifier: Scalars['String']['input'];
}>;


export type ChangeStudyIdentifierMutation = { readonly __typename: 'Mutation', readonly changeStudyIdentifier?: { readonly __typename: 'ChangeStudyIdentifierPayload', readonly success: boolean, readonly errors?: ReadonlyArray<{ readonly __typename: 'Error', readonly message: string }> | null, readonly study?: { readonly __typename: 'Study', readonly id: string, readonly studyId?: string | null } | null } | null };

export type AdminReviewStudiesQueryVariables = Exact<{
  reviewId: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<StudiesFilter>;
}>;


export type AdminReviewStudiesQuery = { readonly __typename: 'Query', readonly review?:
    | { readonly __typename: 'CochraneReview' }
    | { readonly __typename: 'CochraneReviewLink' }
    | { readonly __typename: 'Review', readonly studies: { readonly __typename: 'StudyConnection', readonly pageInfo: { readonly __typename: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly nodes?: ReadonlyArray<{ readonly __typename: 'Study', readonly id: string, readonly covidenceNumber: number, readonly studyId?: string | null, readonly displayTitle: string } | null> | null } }
    | { readonly __typename: 'DuplicateCluster' }
    | { readonly __typename: 'User' }
    | { readonly __typename: 'Account' }
    | { readonly __typename: 'Organization' }
    | { readonly __typename: 'AuthorExport' }
    | { readonly __typename: 'Invitation' }
    | { readonly __typename: 'Membership' }
    | { readonly __typename: 'Import' }
    | { readonly __typename: 'ExtractionForm' }
    | { readonly __typename: 'ExtractionFormRevision' }
    | { readonly __typename: 'ExtractionStudy' }
    | { readonly __typename: 'Note' }
    | { readonly __typename: 'NoteAuthor' }
    | { readonly __typename: 'Report' }
    | { readonly __typename: 'Document' }
    | { readonly __typename: 'Invite' }
    | { readonly __typename: 'ReviewMembership' }
    | { readonly __typename: 'Study' }
    | { readonly __typename: 'Vote' }
    | { readonly __typename: 'Tag' }
    | { readonly __typename: 'Comment' }
    | { readonly __typename: 'Guideline' }
    | { readonly __typename: 'TopicExpertInvite' }
    | { readonly __typename: 'Topic' }
    | { readonly __typename: 'TopicExpert' }
    | { readonly __typename: 'ConsensusRevision' }
    | { readonly __typename: 'Consensus' }
    | { readonly __typename: 'ExtractedDataRevision' }
    | { readonly __typename: 'StudyExtractor' }
   | null };

export type ReviewStudiesFragment = { readonly __typename: 'StudyConnection', readonly pageInfo: { readonly __typename: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly nodes?: ReadonlyArray<{ readonly __typename: 'Study', readonly id: string, readonly covidenceNumber: number, readonly studyId?: string | null, readonly displayTitle: string } | null> | null };

export type AddNoteToStudyMutationVariables = Exact<{
  input: AddNoteToStudyInput;
}>;


export type AddNoteToStudyMutation = { readonly __typename: 'Mutation', readonly addNoteToStudy?: { readonly __typename: 'AddNoteToStudyPayload', readonly success: boolean, readonly errors?: ReadonlyArray<{ readonly __typename: 'Error', readonly message: string }> | null } | null };

export type GenerateSignedUploadUrlMutationVariables = Exact<{
  referenceId: Scalars['ID']['input'];
  filename: Scalars['String']['input'];
}>;


export type GenerateSignedUploadUrlMutation = { readonly __typename: 'Mutation', readonly generateSignedUploadUrl?: { readonly __typename: 'GenerateSignedUploadUrlPayload', readonly success: boolean, readonly url?: string | null, readonly errors?: ReadonlyArray<{ readonly __typename: 'Error', readonly message: string }> | null } | null };

export type AddUploadedDocumentMutationVariables = Exact<{
  referenceId: Scalars['ID']['input'];
  filename: Scalars['String']['input'];
}>;


export type AddUploadedDocumentMutation = { readonly __typename: 'Mutation', readonly addUploadedDocument?: { readonly __typename: 'AddUploadedDocumentPayload', readonly success: boolean, readonly documents?: ReadonlyArray<{ readonly __typename: 'Document', readonly id: string, readonly fileName?: string | null, readonly url: string, readonly primaryDocument?: boolean | null }> | null, readonly errors?: ReadonlyArray<{ readonly __typename: 'Error', readonly message: string }> | null } | null };

export type EditNoteMutationVariables = Exact<{
  input: EditNoteInput;
}>;


export type EditNoteMutation = { readonly __typename: 'Mutation', readonly editNote?: { readonly __typename: 'EditNotePayload', readonly success: boolean, readonly errors?: ReadonlyArray<{ readonly __typename: 'Error', readonly message: string }> | null } | null };

export type MergeStudiesMutationVariables = Exact<{
  input: MergeStudiesInput;
}>;


export type MergeStudiesMutation = { readonly __typename: 'Mutation', readonly mergeStudies?: { readonly __typename: 'MergeStudiesPayload', readonly success: boolean, readonly errors?: ReadonlyArray<{ readonly __typename: 'Error', readonly message: string }> | null } | null };

export type DeleteDocumentMutationVariables = Exact<{
  documentId: Scalars['ID']['input'];
}>;


export type DeleteDocumentMutation = { readonly __typename: 'Mutation', readonly deleteDocument?: { readonly __typename: 'DeleteDocumentPayload', readonly success: boolean } | null };

export type MarkDocumentAsPrimaryMutationVariables = Exact<{
  documentId: Scalars['ID']['input'];
}>;


export type MarkDocumentAsPrimaryMutation = { readonly __typename: 'Mutation', readonly markDocumentAsPrimary?: { readonly __typename: 'MarkDocumentAsPrimaryPayload', readonly success: boolean, readonly documents: ReadonlyArray<{ readonly __typename: 'Document', readonly id: string, readonly fileName?: string | null, readonly url: string, readonly primaryDocument?: boolean | null }> } | null };

export type RemoveNoteMutationVariables = Exact<{
  input: RemoveNoteInput;
}>;


export type RemoveNoteMutation = { readonly __typename: 'Mutation', readonly removeNote?: { readonly __typename: 'RemoveNotePayload', readonly success: boolean, readonly errors?: ReadonlyArray<{ readonly __typename: 'Error', readonly message: string }> | null } | null };

export type SelectableReviewersQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SelectableReviewersQuery = { readonly __typename: 'Query', readonly review?:
    | { readonly __typename: 'CochraneReview' }
    | { readonly __typename: 'CochraneReviewLink' }
    | { readonly __typename: 'Review', readonly memberships: { readonly __typename: 'ReviewMembershipConnection', readonly nodes?: ReadonlyArray<{ readonly __typename: 'ReviewMembership', readonly reviewer: { readonly __typename: 'User', readonly id: string, readonly name: string } } | null> | null } }
    | { readonly __typename: 'DuplicateCluster' }
    | { readonly __typename: 'User' }
    | { readonly __typename: 'Account' }
    | { readonly __typename: 'Organization' }
    | { readonly __typename: 'AuthorExport' }
    | { readonly __typename: 'Invitation' }
    | { readonly __typename: 'Membership' }
    | { readonly __typename: 'Import' }
    | { readonly __typename: 'ExtractionForm' }
    | { readonly __typename: 'ExtractionFormRevision' }
    | { readonly __typename: 'ExtractionStudy' }
    | { readonly __typename: 'Note' }
    | { readonly __typename: 'NoteAuthor' }
    | { readonly __typename: 'Report' }
    | { readonly __typename: 'Document' }
    | { readonly __typename: 'Invite' }
    | { readonly __typename: 'ReviewMembership' }
    | { readonly __typename: 'Study' }
    | { readonly __typename: 'Vote' }
    | { readonly __typename: 'Tag' }
    | { readonly __typename: 'Comment' }
    | { readonly __typename: 'Guideline' }
    | { readonly __typename: 'TopicExpertInvite' }
    | { readonly __typename: 'Topic' }
    | { readonly __typename: 'TopicExpert' }
    | { readonly __typename: 'ConsensusRevision' }
    | { readonly __typename: 'Consensus' }
    | { readonly __typename: 'ExtractedDataRevision' }
    | { readonly __typename: 'StudyExtractor' }
   | null };

export type ReassignStudyReviewerMutationVariables = Exact<{
  studyId: Scalars['ID']['input'];
  extractorReassignments?: InputMaybe<ReadonlyArray<InputMaybe<ExtractionReassignment>> | InputMaybe<ExtractionReassignment>>;
  consensusReassignment?: InputMaybe<ConsensusReassignment>;
}>;


export type ReassignStudyReviewerMutation = { readonly __typename: 'Mutation', readonly reassignStudyReviewer?: { readonly __typename: 'ReassignStudyReviewerPayload', readonly success: boolean, readonly progress: { readonly __typename: 'ExtractionProgress', readonly status: ExtractionProgressStatus, readonly extractionSlots: ReadonlyArray<{ readonly __typename: 'ExtractionSlot', readonly assigned: boolean, readonly currentUser: boolean, readonly lastActivityAgo?: string | null, readonly completed: boolean, readonly extractor?: { readonly __typename: 'ExtractionSlotUser', readonly id: string, readonly name: string } | null }>, readonly consensusSlot?: { readonly __typename: 'ConsensusSlot', readonly assigned: boolean, readonly currentUser: boolean, readonly lastActivityAgo?: string | null, readonly started: boolean, readonly completed: boolean, readonly decider?: { readonly __typename: 'ExtractionSlotUser', readonly id: string, readonly name: string } | null } | null } } | null };

export type UnmergeStudiesMutationVariables = Exact<{
  input: UnmergeStudiesInput;
}>;


export type UnmergeStudiesMutation = { readonly __typename: 'Mutation', readonly unmergeStudies?: { readonly __typename: 'UnmergeStudiesPayload', readonly success: boolean, readonly errors?: ReadonlyArray<{ readonly __typename: 'Error', readonly message: string }> | null } | null };

export type GetCommentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetCommentQuery = { readonly __typename: 'Query', readonly comment?:
    | { readonly __typename: 'CochraneReview' }
    | { readonly __typename: 'CochraneReviewLink' }
    | { readonly __typename: 'Review' }
    | { readonly __typename: 'DuplicateCluster' }
    | { readonly __typename: 'User' }
    | { readonly __typename: 'Account' }
    | { readonly __typename: 'Organization' }
    | { readonly __typename: 'AuthorExport' }
    | { readonly __typename: 'Invitation' }
    | { readonly __typename: 'Membership' }
    | { readonly __typename: 'Import' }
    | { readonly __typename: 'ExtractionForm' }
    | { readonly __typename: 'ExtractionFormRevision' }
    | { readonly __typename: 'ExtractionStudy' }
    | { readonly __typename: 'Note' }
    | { readonly __typename: 'NoteAuthor' }
    | { readonly __typename: 'Report' }
    | { readonly __typename: 'Document' }
    | { readonly __typename: 'Invite' }
    | { readonly __typename: 'ReviewMembership' }
    | { readonly __typename: 'Study' }
    | { readonly __typename: 'Vote' }
    | { readonly __typename: 'Tag' }
    | { readonly __typename: 'Comment', readonly id: string, readonly content: string, readonly createdAgo: string, readonly activeAgo: string, readonly editedAgo?: string | null, readonly resolvedAgo?: string | null, readonly mentions: ReadonlyArray<{ readonly __typename: 'CommentMention', readonly name: string, readonly replied: boolean }>, readonly activeBy: { readonly __typename: 'User', readonly name: string }, readonly reviewer: { readonly __typename: 'User', readonly name: string }, readonly reviewStudies: ReadonlyArray<{ readonly __typename: 'Study', readonly id: string, readonly title: string, readonly authors?: string | null, readonly studyId?: string | null, readonly covidenceNumber: number, readonly references: { readonly __typename: 'ReportConnection', readonly nodes?: ReadonlyArray<{ readonly __typename: 'Report', readonly abstract?: string | null, readonly journalInfo?: string | null, readonly publisherInfo?: string | null, readonly documents?: ReadonlyArray<{ readonly __typename: 'Document', readonly id: string, readonly url: string, readonly fileName?: string | null }> | null } | null> | null } }>, readonly actions: { readonly __typename: 'CommentActions', readonly canResolve?: boolean | null, readonly canEdit?: boolean | null }, readonly replies?: ReadonlyArray<{ readonly __typename: 'Comment', readonly id: string, readonly content: string, readonly createdAgo: string, readonly editedAgo?: string | null, readonly reviewer: { readonly __typename: 'User', readonly name: string }, readonly actions: { readonly __typename: 'CommentActions', readonly canEdit?: boolean | null } }> | null }
    | { readonly __typename: 'Guideline' }
    | { readonly __typename: 'TopicExpertInvite' }
    | { readonly __typename: 'Topic' }
    | { readonly __typename: 'TopicExpert' }
    | { readonly __typename: 'ConsensusRevision' }
    | { readonly __typename: 'Consensus' }
    | { readonly __typename: 'ExtractedDataRevision' }
    | { readonly __typename: 'StudyExtractor' }
   | null };

export type AddReplyToCommentMutationVariables = Exact<{
  input: AddReplyToCommentInput;
}>;


export type AddReplyToCommentMutation = { readonly __typename: 'Mutation', readonly addReplyToComment?: { readonly __typename: 'AddReplyToCommentPayload', readonly success: boolean, readonly errors?: ReadonlyArray<{ readonly __typename: 'Error', readonly message: string }> | null } | null };

export type EditCommentMutationVariables = Exact<{
  input: EditCommentInput;
}>;


export type EditCommentMutation = { readonly __typename: 'Mutation', readonly editComment?: { readonly __typename: 'EditCommentPayload', readonly success: boolean, readonly errors?: ReadonlyArray<{ readonly __typename: 'Error', readonly message: string }> | null } | null };

export type ResolveDiscussionMutationVariables = Exact<{
  input: ResolveDiscussionInput;
}>;


export type ResolveDiscussionMutation = { readonly __typename: 'Mutation', readonly resolveDiscussion?: { readonly __typename: 'ResolveDiscussionPayload', readonly success: boolean, readonly errors?: ReadonlyArray<{ readonly __typename: 'Error', readonly message: string }> | null } | null };

export type GetCommentsQueryVariables = Exact<{
  filter: CommentsFilter;
  sort?: InputMaybe<CommentSort>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCommentsQuery = { readonly __typename: 'Query', readonly comments?: { readonly __typename: 'CommentConnection', readonly pageInfo: { readonly __typename: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly nodes?: ReadonlyArray<{ readonly __typename: 'Comment', readonly id: string, readonly content: string, readonly createdAgo: string, readonly activeAgo: string, readonly mentions: ReadonlyArray<{ readonly __typename: 'CommentMention', readonly name: string, readonly replied: boolean }>, readonly activeBy: { readonly __typename: 'User', readonly name: string }, readonly reviewer: { readonly __typename: 'User', readonly name: string }, readonly reviewStudies: ReadonlyArray<{ readonly __typename: 'Study', readonly id: string, readonly title: string, readonly authors?: string | null, readonly studyId?: string | null, readonly covidenceNumber: number, readonly references: { readonly __typename: 'ReportConnection', readonly nodes?: ReadonlyArray<{ readonly __typename: 'Report', readonly abstract?: string | null, readonly journalInfo?: string | null, readonly publisherInfo?: string | null, readonly documents?: ReadonlyArray<{ readonly __typename: 'Document', readonly id: string, readonly url: string, readonly fileName?: string | null }> | null } | null> | null } }>, readonly actions: { readonly __typename: 'CommentActions', readonly showUrl?: string | null } } | null> | null } | null };

export type CreateExtractionFormRevisionMutationVariables = Exact<{
  extractionFormRevision: CreateExtractionFormRevisionInput;
}>;


export type CreateExtractionFormRevisionMutation = { readonly __typename: 'Mutation', readonly createExtractionFormRevision?: { readonly __typename: 'CreateExtractionFormRevisionPayload', readonly success: boolean, readonly errors?: ReadonlyArray<{ readonly __typename: 'Error', readonly message: string }> | null } | null };

export type CompleteExtractionFormMutationVariables = Exact<{
  extractionFormRevision: CompleteExtractionFormInput;
}>;


export type CompleteExtractionFormMutation = { readonly __typename: 'Mutation', readonly completeExtractionForm?: { readonly __typename: 'CompleteExtractionFormPayload', readonly success: boolean, readonly errors?: ReadonlyArray<{ readonly __typename: 'Error', readonly message: string }> | null } | null };

export type RevertTemplateMutationVariables = Exact<{
  params: RevertTemplateInput;
}>;


export type RevertTemplateMutation = { readonly __typename: 'Mutation', readonly response?: { readonly __typename: 'RevertTemplatePayload', readonly success: boolean, readonly errors?: ReadonlyArray<{ readonly __typename: 'Error', readonly message: string }> | null } | null };

export type SaveConsensusMutationVariables = Exact<{
  input: SaveConsensusInput;
}>;


export type SaveConsensusMutation = { readonly __typename: 'Mutation', readonly saveConsensus?: { readonly __typename: 'SaveConsensusPayload', readonly success: boolean, readonly errors?: ReadonlyArray<{ readonly __typename: 'Error', readonly message: string }> | null } | null };

export type CompleteConsensusMutationVariables = Exact<{
  input: CompleteConsensusInput;
}>;


export type CompleteConsensusMutation = { readonly __typename: 'Mutation', readonly completeConsensus?: { readonly __typename: 'CompleteConsensusPayload', readonly success: boolean, readonly errors?: ReadonlyArray<{ readonly __typename: 'Error', readonly message: string }> | null } | null };

export type SaveExtractedDataMutationVariables = Exact<{
  input: SaveExtractedDataInput;
}>;


export type SaveExtractedDataMutation = { readonly __typename: 'Mutation', readonly saveExtractedData?: { readonly __typename: 'SaveExtractedDataPayload', readonly success: boolean, readonly errors?: ReadonlyArray<{ readonly __typename: 'Error', readonly message: string }> | null } | null };

export type CompleteExtractedDataMutationVariables = Exact<{
  input: CompleteExtractedDataInput;
}>;


export type CompleteExtractedDataMutation = { readonly __typename: 'Mutation', readonly completeExtractedData?: { readonly __typename: 'CompleteExtractedDataPayload', readonly success: boolean, readonly errors?: ReadonlyArray<{ readonly __typename: 'Error', readonly message: string }> | null } | null };

export type StudyListQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  count: Scalars['Int']['input'];
  sort?: InputMaybe<ExtractionStudySort>;
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ExtractionStudiesFilter>;
  filterByTags?: InputMaybe<ReadonlyArray<Scalars['String']['input']> | Scalars['String']['input']>;
  studyId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type StudyListQuery = { readonly __typename: 'Query', readonly review?:
    | { readonly __typename: 'CochraneReview' }
    | { readonly __typename: 'CochraneReviewLink' }
    | { readonly __typename: 'Review', readonly tags: ReadonlyArray<{ readonly __typename: 'Tag', readonly name: string }>, readonly studies: { readonly __typename: 'ExtractionStudyConnection', readonly pageInfo: { readonly __typename: 'PageInfo', readonly startCursor?: string | null, readonly endCursor?: string | null, readonly hasNextPage: boolean, readonly hasPreviousPage: boolean }, readonly nodes?: ReadonlyArray<{ readonly __typename: 'ExtractionStudy', readonly id: string, readonly studyId?: string | null, readonly tags: ReadonlyArray<string>, readonly covidenceNumber: number, readonly title?: string | null, readonly authors?: string | null, readonly notes: ReadonlyArray<{ readonly __typename: 'Note', readonly id: string, readonly note: string, readonly createdAt: string, readonly updatedAt: string, readonly author: { readonly __typename: 'NoteAuthor', readonly id: string, readonly name: string } }>, readonly references: { readonly __typename: 'ReportConnection', readonly nodes?: ReadonlyArray<{ readonly __typename: 'Report', readonly id: string, readonly title?: string | null, readonly authors: string, readonly fullText: boolean, readonly referenceUrl?: string | null, readonly source?: string | null, readonly publisherInfo?: string | null, readonly journalInfo?: string | null, readonly documents?: ReadonlyArray<{ readonly __typename: 'Document', readonly id: string, readonly primaryDocument?: boolean | null, readonly url: string, readonly fileName?: string | null }> | null } | null> | null }, readonly actions: { readonly __typename: 'StudyActions', readonly extractUrl?: string | null, readonly compareUrl?: string | null, readonly editCompareUrl?: string | null }, readonly progress: { readonly __typename: 'ExtractionProgress', readonly status: ExtractionProgressStatus, readonly consensusSlot?: { readonly __typename: 'ConsensusSlot', readonly assigned: boolean, readonly currentUser: boolean, readonly lastActivityAgo?: string | null, readonly started: boolean, readonly completed: boolean, readonly decider?: { readonly __typename: 'ExtractionSlotUser', readonly id: string, readonly name: string } | null } | null, readonly extractionSlots: ReadonlyArray<{ readonly __typename: 'ExtractionSlot', readonly assigned: boolean, readonly currentUser: boolean, readonly lastActivityAgo?: string | null, readonly completed: boolean, readonly extractor?: { readonly __typename: 'ExtractionSlotUser', readonly id: string, readonly name: string } | null }> } } | null> | null } }
    | { readonly __typename: 'DuplicateCluster' }
    | { readonly __typename: 'User' }
    | { readonly __typename: 'Account' }
    | { readonly __typename: 'Organization' }
    | { readonly __typename: 'AuthorExport' }
    | { readonly __typename: 'Invitation' }
    | { readonly __typename: 'Membership' }
    | { readonly __typename: 'Import' }
    | { readonly __typename: 'ExtractionForm' }
    | { readonly __typename: 'ExtractionFormRevision' }
    | { readonly __typename: 'ExtractionStudy' }
    | { readonly __typename: 'Note' }
    | { readonly __typename: 'NoteAuthor' }
    | { readonly __typename: 'Report' }
    | { readonly __typename: 'Document' }
    | { readonly __typename: 'Invite' }
    | { readonly __typename: 'ReviewMembership' }
    | { readonly __typename: 'Study' }
    | { readonly __typename: 'Vote' }
    | { readonly __typename: 'Tag' }
    | { readonly __typename: 'Comment' }
    | { readonly __typename: 'Guideline' }
    | { readonly __typename: 'TopicExpertInvite' }
    | { readonly __typename: 'Topic' }
    | { readonly __typename: 'TopicExpert' }
    | { readonly __typename: 'ConsensusRevision' }
    | { readonly __typename: 'Consensus' }
    | { readonly __typename: 'ExtractedDataRevision' }
    | { readonly __typename: 'StudyExtractor' }
   | null };

export type MoveStudyToFullTextMutationVariables = Exact<{
  input: RecordStudyVoteInput;
}>;


export type MoveStudyToFullTextMutation = { readonly __typename: 'Mutation', readonly recordStudyVote?: { readonly __typename: 'RecordStudyVotePayload', readonly success: boolean, readonly errors?: ReadonlyArray<{ readonly __typename: 'Error', readonly message: string }> | null } | null };

export type GetTopicExpertInvitesQueryVariables = Exact<{
  guidelineId: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetTopicExpertInvitesQuery = { readonly __typename: 'Query', readonly guideline?:
    | { readonly __typename: 'CochraneReview', readonly id: string }
    | { readonly __typename: 'CochraneReviewLink', readonly id: string }
    | { readonly __typename: 'Review', readonly id: string }
    | { readonly __typename: 'DuplicateCluster', readonly id: string }
    | { readonly __typename: 'User', readonly id: string }
    | { readonly __typename: 'Account', readonly id: string }
    | { readonly __typename: 'Organization', readonly id: string }
    | { readonly __typename: 'AuthorExport', readonly id: string }
    | { readonly __typename: 'Invitation', readonly id: string }
    | { readonly __typename: 'Membership', readonly id: string }
    | { readonly __typename: 'Import', readonly id: string }
    | { readonly __typename: 'ExtractionForm', readonly id: string }
    | { readonly __typename: 'ExtractionFormRevision', readonly id: string }
    | { readonly __typename: 'ExtractionStudy', readonly id: string }
    | { readonly __typename: 'Note', readonly id: string }
    | { readonly __typename: 'NoteAuthor', readonly id: string }
    | { readonly __typename: 'Report', readonly id: string }
    | { readonly __typename: 'Document', readonly id: string }
    | { readonly __typename: 'Invite', readonly id: string }
    | { readonly __typename: 'ReviewMembership', readonly id: string }
    | { readonly __typename: 'Study', readonly id: string }
    | { readonly __typename: 'Vote', readonly id: string }
    | { readonly __typename: 'Tag', readonly id: string }
    | { readonly __typename: 'Comment', readonly id: string }
    | { readonly __typename: 'Guideline', readonly id: string, readonly name: string, readonly topics?: { readonly __typename: 'TopicConnection', readonly nodes?: ReadonlyArray<{ readonly __typename: 'Topic', readonly id: string, readonly name: string } | null> | null } | null, readonly topicExpertInvites?: { readonly __typename: 'TopicExpertInviteConnection', readonly pageInfo: { readonly __typename: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly nodes?: ReadonlyArray<{ readonly __typename: 'TopicExpertInvite', readonly id: string, readonly createdAt: any, readonly name: string, readonly email: string, readonly expertTopics: ReadonlyArray<{ readonly __typename: 'Topic', readonly id: string, readonly name: string }> } | null> | null } | null }
    | { readonly __typename: 'TopicExpertInvite', readonly id: string }
    | { readonly __typename: 'Topic', readonly id: string }
    | { readonly __typename: 'TopicExpert', readonly id: string }
    | { readonly __typename: 'ConsensusRevision', readonly id: string }
    | { readonly __typename: 'Consensus', readonly id: string }
    | { readonly __typename: 'ExtractedDataRevision', readonly id: string }
    | { readonly __typename: 'StudyExtractor', readonly id: string }
   | null };

export type InviteTopicExpertMutationVariables = Exact<{
  input: InviteTopicExpertInput;
}>;


export type InviteTopicExpertMutation = { readonly __typename: 'Mutation', readonly inviteTopicExpert?: { readonly __typename: 'InviteTopicExpertPayload', readonly success: boolean, readonly errors?: ReadonlyArray<{ readonly __typename: 'Error', readonly message: string }> | null } | null };

export type CancelTopicExpertInviteMutationVariables = Exact<{
  input: CancelTopicExpertInviteInput;
}>;


export type CancelTopicExpertInviteMutation = { readonly __typename: 'Mutation', readonly cancelTopicExpertInvite?: { readonly __typename: 'CancelTopicExpertInvitePayload', readonly success: boolean, readonly errors?: ReadonlyArray<{ readonly __typename: 'Error', readonly message: string }> | null } | null };

export type ResendTopicExpertInviteMutationVariables = Exact<{
  input: ResendTopicExpertInviteInput;
}>;


export type ResendTopicExpertInviteMutation = { readonly __typename: 'Mutation', readonly resendTopicExpertInvite?: { readonly __typename: 'ResendTopicExpertInvitePayload', readonly success: boolean, readonly errors?: ReadonlyArray<{ readonly __typename: 'Error', readonly message: string }> | null } | null };

export type GetTopicExpertsQueryVariables = Exact<{
  guidelineId: Scalars['ID']['input'];
}>;


export type GetTopicExpertsQuery = { readonly __typename: 'Query', readonly guideline?:
    | { readonly __typename: 'CochraneReview', readonly id: string }
    | { readonly __typename: 'CochraneReviewLink', readonly id: string }
    | { readonly __typename: 'Review', readonly id: string }
    | { readonly __typename: 'DuplicateCluster', readonly id: string }
    | { readonly __typename: 'User', readonly id: string }
    | { readonly __typename: 'Account', readonly id: string }
    | { readonly __typename: 'Organization', readonly id: string }
    | { readonly __typename: 'AuthorExport', readonly id: string }
    | { readonly __typename: 'Invitation', readonly id: string }
    | { readonly __typename: 'Membership', readonly id: string }
    | { readonly __typename: 'Import', readonly id: string }
    | { readonly __typename: 'ExtractionForm', readonly id: string }
    | { readonly __typename: 'ExtractionFormRevision', readonly id: string }
    | { readonly __typename: 'ExtractionStudy', readonly id: string }
    | { readonly __typename: 'Note', readonly id: string }
    | { readonly __typename: 'NoteAuthor', readonly id: string }
    | { readonly __typename: 'Report', readonly id: string }
    | { readonly __typename: 'Document', readonly id: string }
    | { readonly __typename: 'Invite', readonly id: string }
    | { readonly __typename: 'ReviewMembership', readonly id: string }
    | { readonly __typename: 'Study', readonly id: string }
    | { readonly __typename: 'Vote', readonly id: string }
    | { readonly __typename: 'Tag', readonly id: string }
    | { readonly __typename: 'Comment', readonly id: string }
    | { readonly __typename: 'Guideline', readonly id: string, readonly name: string, readonly actions: { readonly __typename: 'GuidelineActions', readonly canInviteTopicExpert: boolean, readonly inviteTopicExpertUrl: string }, readonly topicExperts?: { readonly __typename: 'TopicExpertConnection', readonly pageInfo: { readonly __typename: 'PageInfo', readonly startCursor?: string | null, readonly endCursor?: string | null, readonly hasNextPage: boolean, readonly hasPreviousPage: boolean }, readonly nodes?: ReadonlyArray<{ readonly __typename: 'TopicExpert', readonly id: string, readonly name: string, readonly email: string, readonly expertTopics: ReadonlyArray<{ readonly __typename: 'Topic', readonly id: string, readonly name: string }> } | null> | null } | null }
    | { readonly __typename: 'TopicExpertInvite', readonly id: string }
    | { readonly __typename: 'Topic', readonly id: string }
    | { readonly __typename: 'TopicExpert', readonly id: string }
    | { readonly __typename: 'ConsensusRevision', readonly id: string }
    | { readonly __typename: 'Consensus', readonly id: string }
    | { readonly __typename: 'ExtractedDataRevision', readonly id: string }
    | { readonly __typename: 'StudyExtractor', readonly id: string }
   | null };

export type DeleteTopicExpertMutationVariables = Exact<{
  input: DeleteTopicExpertInput;
}>;


export type DeleteTopicExpertMutation = { readonly __typename: 'Mutation', readonly deleteTopicExpert?: { readonly __typename: 'DeleteTopicExpertPayload', readonly success: boolean, readonly errors?: ReadonlyArray<{ readonly __typename: 'Error', readonly message: string }> | null } | null };

export type OrganizationOverviewCountsQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type OrganizationOverviewCountsQuery = { readonly __typename: 'Query', readonly organization?:
    | { readonly __typename: 'CochraneReview', readonly id: string }
    | { readonly __typename: 'CochraneReviewLink', readonly id: string }
    | { readonly __typename: 'Review', readonly id: string }
    | { readonly __typename: 'DuplicateCluster', readonly id: string }
    | { readonly __typename: 'User', readonly id: string }
    | { readonly __typename: 'Account', readonly id: string }
    | { readonly __typename: 'Organization', readonly id: string, readonly reviews: { readonly __typename: 'ReviewConnection', readonly total: number }, readonly authors: { readonly __typename: 'UserConnection', readonly total: number }, readonly unassignedReviews: { readonly __typename: 'ReviewConnection', readonly total: number } }
    | { readonly __typename: 'AuthorExport', readonly id: string }
    | { readonly __typename: 'Invitation', readonly id: string }
    | { readonly __typename: 'Membership', readonly id: string }
    | { readonly __typename: 'Import', readonly id: string }
    | { readonly __typename: 'ExtractionForm', readonly id: string }
    | { readonly __typename: 'ExtractionFormRevision', readonly id: string }
    | { readonly __typename: 'ExtractionStudy', readonly id: string }
    | { readonly __typename: 'Note', readonly id: string }
    | { readonly __typename: 'NoteAuthor', readonly id: string }
    | { readonly __typename: 'Report', readonly id: string }
    | { readonly __typename: 'Document', readonly id: string }
    | { readonly __typename: 'Invite', readonly id: string }
    | { readonly __typename: 'ReviewMembership', readonly id: string }
    | { readonly __typename: 'Study', readonly id: string }
    | { readonly __typename: 'Vote', readonly id: string }
    | { readonly __typename: 'Tag', readonly id: string }
    | { readonly __typename: 'Comment', readonly id: string }
    | { readonly __typename: 'Guideline', readonly id: string }
    | { readonly __typename: 'TopicExpertInvite', readonly id: string }
    | { readonly __typename: 'Topic', readonly id: string }
    | { readonly __typename: 'TopicExpert', readonly id: string }
    | { readonly __typename: 'ConsensusRevision', readonly id: string }
    | { readonly __typename: 'Consensus', readonly id: string }
    | { readonly __typename: 'ExtractedDataRevision', readonly id: string }
    | { readonly __typename: 'StudyExtractor', readonly id: string }
   | null };

export type OrganizationReviewsSearchQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  q: Scalars['String']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type OrganizationReviewsSearchQuery = { readonly __typename: 'Query', readonly organization?:
    | { readonly __typename: 'CochraneReview', readonly id: string }
    | { readonly __typename: 'CochraneReviewLink', readonly id: string }
    | { readonly __typename: 'Review', readonly id: string }
    | { readonly __typename: 'DuplicateCluster', readonly id: string }
    | { readonly __typename: 'User', readonly id: string }
    | { readonly __typename: 'Account', readonly id: string }
    | { readonly __typename: 'Organization', readonly id: string, readonly reviews: { readonly __typename: 'ReviewConnection', readonly total: number, readonly pageInfo: { readonly __typename: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly nodes?: ReadonlyArray<{ readonly __typename: 'Review', readonly id: string, readonly title: string, readonly lastActivityAt: any, readonly collaborators: { readonly __typename: 'UserConnection', readonly total: number }, readonly assignedAdministrator?: { readonly __typename: 'User', readonly name: string } | null } | null> | null } }
    | { readonly __typename: 'AuthorExport', readonly id: string }
    | { readonly __typename: 'Invitation', readonly id: string }
    | { readonly __typename: 'Membership', readonly id: string }
    | { readonly __typename: 'Import', readonly id: string }
    | { readonly __typename: 'ExtractionForm', readonly id: string }
    | { readonly __typename: 'ExtractionFormRevision', readonly id: string }
    | { readonly __typename: 'ExtractionStudy', readonly id: string }
    | { readonly __typename: 'Note', readonly id: string }
    | { readonly __typename: 'NoteAuthor', readonly id: string }
    | { readonly __typename: 'Report', readonly id: string }
    | { readonly __typename: 'Document', readonly id: string }
    | { readonly __typename: 'Invite', readonly id: string }
    | { readonly __typename: 'ReviewMembership', readonly id: string }
    | { readonly __typename: 'Study', readonly id: string }
    | { readonly __typename: 'Vote', readonly id: string }
    | { readonly __typename: 'Tag', readonly id: string }
    | { readonly __typename: 'Comment', readonly id: string }
    | { readonly __typename: 'Guideline', readonly id: string }
    | { readonly __typename: 'TopicExpertInvite', readonly id: string }
    | { readonly __typename: 'Topic', readonly id: string }
    | { readonly __typename: 'TopicExpert', readonly id: string }
    | { readonly __typename: 'ConsensusRevision', readonly id: string }
    | { readonly __typename: 'Consensus', readonly id: string }
    | { readonly __typename: 'ExtractedDataRevision', readonly id: string }
    | { readonly __typename: 'StudyExtractor', readonly id: string }
   | null };

export type OrganizationAuthorsSearchQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  q: Scalars['String']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type OrganizationAuthorsSearchQuery = { readonly __typename: 'Query', readonly organization?:
    | { readonly __typename: 'CochraneReview', readonly id: string }
    | { readonly __typename: 'CochraneReviewLink', readonly id: string }
    | { readonly __typename: 'Review', readonly id: string }
    | { readonly __typename: 'DuplicateCluster', readonly id: string }
    | { readonly __typename: 'User', readonly id: string }
    | { readonly __typename: 'Account', readonly id: string }
    | { readonly __typename: 'Organization', readonly id: string, readonly authors: { readonly __typename: 'UserConnection', readonly total: number, readonly pageInfo: { readonly __typename: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly nodes?: ReadonlyArray<{ readonly __typename: 'User', readonly id: string, readonly name: string, readonly primaryEmail: any, readonly organizationMembership: { readonly __typename: 'Membership', readonly status: MembershipStatus, readonly memberSince?: any | null, readonly organizationReviews?: { readonly __typename: 'ReviewConnection', readonly total: number } | null } } | null> | null } }
    | { readonly __typename: 'AuthorExport', readonly id: string }
    | { readonly __typename: 'Invitation', readonly id: string }
    | { readonly __typename: 'Membership', readonly id: string }
    | { readonly __typename: 'Import', readonly id: string }
    | { readonly __typename: 'ExtractionForm', readonly id: string }
    | { readonly __typename: 'ExtractionFormRevision', readonly id: string }
    | { readonly __typename: 'ExtractionStudy', readonly id: string }
    | { readonly __typename: 'Note', readonly id: string }
    | { readonly __typename: 'NoteAuthor', readonly id: string }
    | { readonly __typename: 'Report', readonly id: string }
    | { readonly __typename: 'Document', readonly id: string }
    | { readonly __typename: 'Invite', readonly id: string }
    | { readonly __typename: 'ReviewMembership', readonly id: string }
    | { readonly __typename: 'Study', readonly id: string }
    | { readonly __typename: 'Vote', readonly id: string }
    | { readonly __typename: 'Tag', readonly id: string }
    | { readonly __typename: 'Comment', readonly id: string }
    | { readonly __typename: 'Guideline', readonly id: string }
    | { readonly __typename: 'TopicExpertInvite', readonly id: string }
    | { readonly __typename: 'Topic', readonly id: string }
    | { readonly __typename: 'TopicExpert', readonly id: string }
    | { readonly __typename: 'ConsensusRevision', readonly id: string }
    | { readonly __typename: 'Consensus', readonly id: string }
    | { readonly __typename: 'ExtractedDataRevision', readonly id: string }
    | { readonly __typename: 'StudyExtractor', readonly id: string }
   | null };

export type CreateCommentMutationVariables = Exact<{
  input: CreateCommentInput;
}>;


export type CreateCommentMutation = { readonly __typename: 'Mutation', readonly createComment?: { readonly __typename: 'CreateCommentPayload', readonly success: boolean, readonly errors?: ReadonlyArray<{ readonly __typename: 'Error', readonly message: string }> | null } | null };

export type ImportFragment = { readonly __typename: 'Import', readonly id: string, readonly defaultCategory: Category, readonly state: ImportState, readonly isFinished: boolean, readonly source: ImportSource, readonly createdAt: any, readonly importedStudiesCount: number, readonly detectedCitationsCount: number, readonly duplicateCitationsCount: number, readonly error?: { readonly __typename: 'Error', readonly message: string } | null };

export type ImportActivityQueryVariables = Exact<{
  reviewId: Scalars['ID']['input'];
}>;


export type ImportActivityQuery = { readonly __typename: 'Query', readonly review?:
    | { readonly __typename: 'CochraneReview' }
    | { readonly __typename: 'CochraneReviewLink' }
    | { readonly __typename: 'Review', readonly duplicates: { readonly __typename: 'DuplicateConnection', readonly totalDuplicates: number }, readonly currentImport?: { readonly __typename: 'Import', readonly id: string, readonly defaultCategory: Category, readonly state: ImportState, readonly isFinished: boolean, readonly source: ImportSource, readonly createdAt: any, readonly importedStudiesCount: number, readonly detectedCitationsCount: number, readonly duplicateCitationsCount: number, readonly error?: { readonly __typename: 'Error', readonly message: string } | null } | null, readonly imports: { readonly __typename: 'ImportConnection', readonly nodes?: ReadonlyArray<{ readonly __typename: 'Import', readonly id: string, readonly defaultCategory: Category, readonly state: ImportState, readonly isFinished: boolean, readonly source: ImportSource, readonly createdAt: any, readonly importedStudiesCount: number, readonly detectedCitationsCount: number, readonly duplicateCitationsCount: number, readonly error?: { readonly __typename: 'Error', readonly message: string } | null } | null> | null } }
    | { readonly __typename: 'DuplicateCluster' }
    | { readonly __typename: 'User' }
    | { readonly __typename: 'Account' }
    | { readonly __typename: 'Organization' }
    | { readonly __typename: 'AuthorExport' }
    | { readonly __typename: 'Invitation' }
    | { readonly __typename: 'Membership' }
    | { readonly __typename: 'Import' }
    | { readonly __typename: 'ExtractionForm' }
    | { readonly __typename: 'ExtractionFormRevision' }
    | { readonly __typename: 'ExtractionStudy' }
    | { readonly __typename: 'Note' }
    | { readonly __typename: 'NoteAuthor' }
    | { readonly __typename: 'Report' }
    | { readonly __typename: 'Document' }
    | { readonly __typename: 'Invite' }
    | { readonly __typename: 'ReviewMembership' }
    | { readonly __typename: 'Study' }
    | { readonly __typename: 'Vote' }
    | { readonly __typename: 'Tag' }
    | { readonly __typename: 'Comment' }
    | { readonly __typename: 'Guideline' }
    | { readonly __typename: 'TopicExpertInvite' }
    | { readonly __typename: 'Topic' }
    | { readonly __typename: 'TopicExpert' }
    | { readonly __typename: 'ConsensusRevision' }
    | { readonly __typename: 'Consensus' }
    | { readonly __typename: 'ExtractedDataRevision' }
    | { readonly __typename: 'StudyExtractor' }
   | null };

export type GetPendingReviewsQueryVariables = Exact<{
  reviewId: Scalars['ID']['input'];
}>;


export type GetPendingReviewsQuery = { readonly __typename: 'Query', readonly review?:
    | { readonly __typename: 'CochraneReview' }
    | { readonly __typename: 'CochraneReviewLink' }
    | { readonly __typename: 'Review', readonly enabledFeatures: ReadonlyArray<string>, readonly cochraneReviewLink?: { readonly __typename: 'CochraneReviewLink', readonly crsPendingStudiesCount?: number | null } | null, readonly currentImport?: { readonly __typename: 'Import', readonly id: string, readonly isFinished: boolean } | null }
    | { readonly __typename: 'DuplicateCluster' }
    | { readonly __typename: 'User' }
    | { readonly __typename: 'Account' }
    | { readonly __typename: 'Organization' }
    | { readonly __typename: 'AuthorExport' }
    | { readonly __typename: 'Invitation' }
    | { readonly __typename: 'Membership' }
    | { readonly __typename: 'Import' }
    | { readonly __typename: 'ExtractionForm' }
    | { readonly __typename: 'ExtractionFormRevision' }
    | { readonly __typename: 'ExtractionStudy' }
    | { readonly __typename: 'Note' }
    | { readonly __typename: 'NoteAuthor' }
    | { readonly __typename: 'Report' }
    | { readonly __typename: 'Document' }
    | { readonly __typename: 'Invite' }
    | { readonly __typename: 'ReviewMembership' }
    | { readonly __typename: 'Study' }
    | { readonly __typename: 'Vote' }
    | { readonly __typename: 'Tag' }
    | { readonly __typename: 'Comment' }
    | { readonly __typename: 'Guideline' }
    | { readonly __typename: 'TopicExpertInvite' }
    | { readonly __typename: 'Topic' }
    | { readonly __typename: 'TopicExpert' }
    | { readonly __typename: 'ConsensusRevision' }
    | { readonly __typename: 'Consensus' }
    | { readonly __typename: 'ExtractedDataRevision' }
    | { readonly __typename: 'StudyExtractor' }
   | null };

export type ReviewCrsImportStatusQueryVariables = Exact<{
  reviewId: Scalars['ID']['input'];
}>;


export type ReviewCrsImportStatusQuery = { readonly __typename: 'Query', readonly review?:
    | { readonly __typename: 'CochraneReview' }
    | { readonly __typename: 'CochraneReviewLink' }
    | { readonly __typename: 'Review', readonly cochraneReviewLink?: { readonly __typename: 'CochraneReviewLink', readonly id: string, readonly crsPendingStudiesCount?: number | null } | null }
    | { readonly __typename: 'DuplicateCluster' }
    | { readonly __typename: 'User' }
    | { readonly __typename: 'Account' }
    | { readonly __typename: 'Organization' }
    | { readonly __typename: 'AuthorExport' }
    | { readonly __typename: 'Invitation' }
    | { readonly __typename: 'Membership' }
    | { readonly __typename: 'Import' }
    | { readonly __typename: 'ExtractionForm' }
    | { readonly __typename: 'ExtractionFormRevision' }
    | { readonly __typename: 'ExtractionStudy' }
    | { readonly __typename: 'Note' }
    | { readonly __typename: 'NoteAuthor' }
    | { readonly __typename: 'Report' }
    | { readonly __typename: 'Document' }
    | { readonly __typename: 'Invite' }
    | { readonly __typename: 'ReviewMembership' }
    | { readonly __typename: 'Study' }
    | { readonly __typename: 'Vote' }
    | { readonly __typename: 'Tag' }
    | { readonly __typename: 'Comment' }
    | { readonly __typename: 'Guideline' }
    | { readonly __typename: 'TopicExpertInvite' }
    | { readonly __typename: 'Topic' }
    | { readonly __typename: 'TopicExpert' }
    | { readonly __typename: 'ConsensusRevision' }
    | { readonly __typename: 'Consensus' }
    | { readonly __typename: 'ExtractedDataRevision' }
    | { readonly __typename: 'StudyExtractor' }
   | null };

export type InitiateCrsImportMutationVariables = Exact<{
  cochraneId: Scalars['ID']['input'];
}>;


export type InitiateCrsImportMutation = { readonly __typename: 'Mutation', readonly initiateCrsImport?: { readonly __typename: 'InitiateCRSImportPayload', readonly success: boolean } | null };

export type ScreeningReviewQueryVariables = Exact<{
  reviewId: Scalars['ID']['input'];
}>;


export type ScreeningReviewQuery = { readonly __typename: 'Query', readonly review?:
    | { readonly __typename: 'CochraneReview' }
    | { readonly __typename: 'CochraneReviewLink' }
    | { readonly __typename: 'Review', readonly id: string, readonly title: string, readonly includedKeywords: ReadonlyArray<string>, readonly excludedKeywords: ReadonlyArray<string> }
    | { readonly __typename: 'DuplicateCluster' }
    | { readonly __typename: 'User' }
    | { readonly __typename: 'Account' }
    | { readonly __typename: 'Organization' }
    | { readonly __typename: 'AuthorExport' }
    | { readonly __typename: 'Invitation' }
    | { readonly __typename: 'Membership' }
    | { readonly __typename: 'Import' }
    | { readonly __typename: 'ExtractionForm' }
    | { readonly __typename: 'ExtractionFormRevision' }
    | { readonly __typename: 'ExtractionStudy' }
    | { readonly __typename: 'Note' }
    | { readonly __typename: 'NoteAuthor' }
    | { readonly __typename: 'Report' }
    | { readonly __typename: 'Document' }
    | { readonly __typename: 'Invite' }
    | { readonly __typename: 'ReviewMembership' }
    | { readonly __typename: 'Study' }
    | { readonly __typename: 'Vote' }
    | { readonly __typename: 'Tag' }
    | { readonly __typename: 'Comment' }
    | { readonly __typename: 'Guideline' }
    | { readonly __typename: 'TopicExpertInvite' }
    | { readonly __typename: 'Topic' }
    | { readonly __typename: 'TopicExpert' }
    | { readonly __typename: 'ConsensusRevision' }
    | { readonly __typename: 'Consensus' }
    | { readonly __typename: 'ExtractedDataRevision' }
    | { readonly __typename: 'StudyExtractor' }
   | null };

export type ReviewStudyScreeningQueryVariables = Exact<{
  reviewId: Scalars['ID']['input'];
  reviewerId: Scalars['ID']['input'];
  excludedStudyIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type ReviewStudyScreeningQuery = { readonly __typename: 'Query', readonly review?:
    | { readonly __typename: 'CochraneReview' }
    | { readonly __typename: 'CochraneReviewLink' }
    | { readonly __typename: 'Review', readonly id: string, readonly title: string, readonly includedKeywords: ReadonlyArray<string>, readonly excludedKeywords: ReadonlyArray<string>, readonly studiesAvailableForVoting: ReadonlyArray<{ readonly __typename: 'Study', readonly id: string, readonly covidenceNumber: number, readonly references: { readonly __typename: 'ReportConnection', readonly nodes?: ReadonlyArray<{ readonly __typename: 'Report', readonly primaryAuthor: string, readonly title?: string | null, readonly abstract?: string | null, readonly publication?: { readonly __typename: 'Publication', readonly year?: string | null } | null } | null> | null } }> }
    | { readonly __typename: 'DuplicateCluster' }
    | { readonly __typename: 'User' }
    | { readonly __typename: 'Account' }
    | { readonly __typename: 'Organization' }
    | { readonly __typename: 'AuthorExport' }
    | { readonly __typename: 'Invitation' }
    | { readonly __typename: 'Membership' }
    | { readonly __typename: 'Import' }
    | { readonly __typename: 'ExtractionForm' }
    | { readonly __typename: 'ExtractionFormRevision' }
    | { readonly __typename: 'ExtractionStudy' }
    | { readonly __typename: 'Note' }
    | { readonly __typename: 'NoteAuthor' }
    | { readonly __typename: 'Report' }
    | { readonly __typename: 'Document' }
    | { readonly __typename: 'Invite' }
    | { readonly __typename: 'ReviewMembership' }
    | { readonly __typename: 'Study' }
    | { readonly __typename: 'Vote' }
    | { readonly __typename: 'Tag' }
    | { readonly __typename: 'Comment' }
    | { readonly __typename: 'Guideline' }
    | { readonly __typename: 'TopicExpertInvite' }
    | { readonly __typename: 'Topic' }
    | { readonly __typename: 'TopicExpert' }
    | { readonly __typename: 'ConsensusRevision' }
    | { readonly __typename: 'Consensus' }
    | { readonly __typename: 'ExtractedDataRevision' }
    | { readonly __typename: 'StudyExtractor' }
   | null };

export type ReviewStudyCastVoteMutationVariables = Exact<{
  studyId: Scalars['ID']['input'];
  vote: VoteValue;
}>;


export type ReviewStudyCastVoteMutation = { readonly __typename: 'Mutation', readonly recordStudyVote?: { readonly __typename: 'RecordStudyVotePayload', readonly success: boolean, readonly errors?: ReadonlyArray<{ readonly __typename: 'Error', readonly message: string }> | null } | null };

export type AddTagsToStudiesMutationVariables = Exact<{
  tags: ReadonlyArray<Scalars['String']['input']> | Scalars['String']['input'];
  studyIds: ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type AddTagsToStudiesMutation = { readonly __typename: 'Mutation', readonly addTagsToStudies?: { readonly __typename: 'AddTagsToStudiesPayload', readonly success: boolean } | null };

export type RemoveTagsFromStudiesMutationVariables = Exact<{
  tags: ReadonlyArray<Scalars['String']['input']> | Scalars['String']['input'];
  studyIds: ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type RemoveTagsFromStudiesMutation = { readonly __typename: 'Mutation', readonly removeTagsFromStudies?: { readonly __typename: 'RemoveTagsFromStudiesPayload', readonly success: boolean } | null };

export type MyCochraneReviewsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyCochraneReviewsQuery = { readonly __typename: 'Query', readonly cochrane: { readonly __typename: 'Cochrane', readonly reviews: { readonly __typename: 'CochraneReviewConnection', readonly pageInfo: { readonly __typename: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly nodes?: ReadonlyArray<{ readonly __typename: 'CochraneReview', readonly id: string, readonly cochraneId: string, readonly title: string, readonly link?: { readonly __typename: 'CochraneReviewLink', readonly covidenceReview: { readonly __typename: 'Review', readonly id: string } } | null } | null> | null } } };

export type CreateLinkedCochraneReviewMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  cochraneReviewId: Scalars['ID']['input'];
  enableRctClassifier?: InputMaybe<Scalars['Boolean']['input']>;
  enableRctAutoExclusion?: InputMaybe<Scalars['Boolean']['input']>;
  enableSuggestions?: InputMaybe<Scalars['Boolean']['input']>;
  mainOrPractice: Scalars['String']['input'];
  primaryPurpose: Scalars['String']['input'];
  otherPrimaryPurposeLabel?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateLinkedCochraneReviewMutation = { readonly __typename: 'Mutation', readonly createLinkedCochraneReview?: { readonly __typename: 'CreateLinkedCochraneReviewPayload', readonly success: boolean, readonly errors?: ReadonlyArray<{ readonly __typename: 'Error', readonly message: string }> | null, readonly review?: { readonly __typename: 'Review', readonly id: string, readonly title: string } | null } | null };

export type CreateReviewMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
  reviewType: Scalars['String']['input'];
  otherReviewTypeLabel?: InputMaybe<Scalars['String']['input']>;
  questionType: Scalars['String']['input'];
  otherQuestionTypeLabel?: InputMaybe<Scalars['String']['input']>;
  researchArea: Scalars['String']['input'];
  otherResearchAreaLabel?: InputMaybe<Scalars['String']['input']>;
  mainOrPractice: Scalars['String']['input'];
  primaryPurpose: Scalars['String']['input'];
  otherPrimaryPurposeLabel?: InputMaybe<Scalars['String']['input']>;
  enableRctClassifier?: InputMaybe<Scalars['Boolean']['input']>;
  enableRctAutoExclusion?: InputMaybe<Scalars['Boolean']['input']>;
  enableSuggestions?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateReviewMutation = { readonly __typename: 'Mutation', readonly createReview?: { readonly __typename: 'CreateReviewPayload', readonly success: boolean, readonly errors?: ReadonlyArray<{ readonly __typename: 'Error', readonly message: string }> | null, readonly review?: { readonly __typename: 'Review', readonly id: string, readonly title: string } | null } | null };

export type ReviewersQueryQueryVariables = Exact<{
  reviewId: Scalars['ID']['input'];
}>;


export type ReviewersQueryQuery = { readonly __typename: 'Query', readonly review?:
    | { readonly __typename: 'CochraneReview' }
    | { readonly __typename: 'CochraneReviewLink' }
    | { readonly __typename: 'Review', readonly invites: { readonly __typename: 'InviteConnection', readonly nodes?: ReadonlyArray<{ readonly __typename: 'Invite', readonly id: string, readonly email: string, readonly name: string, readonly createdAt: any, readonly sentAt?: any | null, readonly acceptedAt?: any | null, readonly declinedAt?: any | null, readonly expiresAt: any, readonly accepted: boolean, readonly expired: boolean, readonly declined: boolean, readonly pending: boolean } | null> | null }, readonly memberships: { readonly __typename: 'ReviewMembershipConnection', readonly nodes?: ReadonlyArray<{ readonly __typename: 'ReviewMembership', readonly isCurrentReviewer: boolean, readonly createdAt: any, readonly owner?: boolean | null, readonly canBeRemoved: boolean, readonly reviewer: { readonly __typename: 'User', readonly primaryEmail: any, readonly name: string, readonly id: string } } | null> | null } }
    | { readonly __typename: 'DuplicateCluster' }
    | { readonly __typename: 'User' }
    | { readonly __typename: 'Account' }
    | { readonly __typename: 'Organization' }
    | { readonly __typename: 'AuthorExport' }
    | { readonly __typename: 'Invitation' }
    | { readonly __typename: 'Membership' }
    | { readonly __typename: 'Import' }
    | { readonly __typename: 'ExtractionForm' }
    | { readonly __typename: 'ExtractionFormRevision' }
    | { readonly __typename: 'ExtractionStudy' }
    | { readonly __typename: 'Note' }
    | { readonly __typename: 'NoteAuthor' }
    | { readonly __typename: 'Report' }
    | { readonly __typename: 'Document' }
    | { readonly __typename: 'Invite' }
    | { readonly __typename: 'ReviewMembership' }
    | { readonly __typename: 'Study' }
    | { readonly __typename: 'Vote' }
    | { readonly __typename: 'Tag' }
    | { readonly __typename: 'Comment' }
    | { readonly __typename: 'Guideline' }
    | { readonly __typename: 'TopicExpertInvite' }
    | { readonly __typename: 'Topic' }
    | { readonly __typename: 'TopicExpert' }
    | { readonly __typename: 'ConsensusRevision' }
    | { readonly __typename: 'Consensus' }
    | { readonly __typename: 'ExtractedDataRevision' }
    | { readonly __typename: 'StudyExtractor' }
   | null };

export type RemoveReviewerMutationVariables = Exact<{
  reviewId: Scalars['ID']['input'];
  reviewerId: Scalars['ID']['input'];
}>;


export type RemoveReviewerMutation = { readonly __typename: 'Mutation', readonly removeReviewer?: { readonly __typename: 'RemoveReviewerPayload', readonly success: boolean, readonly errors?: ReadonlyArray<{ readonly __typename: 'Error', readonly message: string }> | null } | null };

export type CancelReviewerInvitationMutationVariables = Exact<{
  invitationId: Scalars['ID']['input'];
}>;


export type CancelReviewerInvitationMutation = { readonly __typename: 'Mutation', readonly cancelInvitation?: { readonly __typename: 'CancelInvitationPayload', readonly success: boolean, readonly errors?: ReadonlyArray<{ readonly __typename: 'Error', readonly message: string }> | null } | null };
